<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div v-if="lmodel !== null && vmodel !== null">
    <TabView class="setting-layout">
      <!-- Setting -->
      <TabPanel header="Settings">
        <div class="grid">
          <div class="col-12 lg:col-11">
            <span class="general-settings-text">
              {{
              staticData.settings.deal_img
              }}
            </span>
          </div>
          <div class="col-12 lg:col-1">
            <label>
              <div class="toggle-button toggleblock-btn">
                <!-- <ToggleButton
                v-model="displayimgwidget"
                onIcon="toggle-on"
                offIcon="toggle-off"
                class="toggle-btn"
                />-->
                <span
                  :class="{
                    'toggle-on': displayimgwidget,
                    'toggle-off': !displayimgwidget,
                  }"
                  @click="displayimgwidget = !displayimgwidget"
                ></span>
              </div>
            </label>
          </div>
        </div>
        <div>
          <div class="grid col-12" v-if="displayimgwidget">
            <span class="general-settings-text">
              {{
              staticData.settings.img_src
              }}
            </span>
          </div>
          <div class="grid" v-if="displayimgwidget">
            <div class="col-12">
              <div class="border-box">
                <PrimeButton
                  label="Image archive"
                  class="rwd-btn"
                  @click="selectImgType('imgarchive')"
                  :class="{ 'active-btn': selectedImgType === 'imgarchive' }"
                  id="imgarchive"
                ></PrimeButton>

                <PrimeButton
                  label="Image url"
                  class="rwd-btn1"
                  @click="selectImgType('imgurl')"
                  :class="{ 'active-btn': selectedImgType === 'imgurl' }"
                  id="imgurl"
                ></PrimeButton>
              </div>
            </div>
          </div>
        </div>

        <!-- Mobile Side-->
        <div
          class="grid"
          v-if="
            selectedImgType === 'imgarchive' &&
            displayimgwidget &&
            selectedDeviceType == 'mobile'
          "
        >
          <div
            :class="
              vmodel1.friMobHeaderimagepath == null ||
              vmodel1.friMobHeaderimagepath === ''
                ? 'field col-12 photo-container1'
                : 'field col-12 photo-container'
            "
          >
            <div
              :class="
                vmodel1.friMobHeaderimagepath == null ||
                vmodel1.friMobHeaderimagepath === ''
                  ? 'photo-sectionimg cursor-pointer'
                  : 'photo-section cursor-pointer'
              "
            >
              <div v-if="!cropperIsActiveMaxWidMob">
                <img
                  v-if="
                    vmodel1.friMobHeaderimagepath !== '' &&
                    vmodel1.friMobHeaderimagepath !== null
                  "
                  :src="vmodel1.friMobHeaderimagepath"
                  alt
                  class="imagefit"
                />
              </div>
              <FileUpload
                type="file"
                id="fileidmobile"
                ref="filemobile"
                accept=".jpeg, .jpg, .gif, .png, .bmp, .tiff"
                @select="handleFileUpload($event)"
                v-show="false"
                :aria-describedby="`photo-help`"
              />
              <div
                v-if="
                  !cropperIsActiveMaxWidMob &&
                  (vmodel1.friMobHeaderimagename == null ||
                    vmodel1.friMobHeaderimagename == '')
                "
                class="upload-icon"
              ></div>
              <span
                v-if="
                  !cropperIsActiveMaxWidMob &&
                  (vmodel1.friMobHeaderimagename == null ||
                    vmodel1.friMobHeaderimagename == '')
                "
              >{{ staticData.settings.dropImg }}</span>
              <PrimeButton
                v-if="
                  !cropperIsActiveMaxWidMob &&
                  (vmodel1.friMobHeaderimagename == null ||
                    vmodel1.friMobHeaderimagename == '')
                "
                label="Browse"
                class="browse-btn"
                icon="pi pi-folder-open"
                @click="openFileUploadMobile"
              />
              <div class="mt-2">
                <PrimeButton
                  v-if="
                    !cropperIsActiveMaxWidMob &&
                    vmodel1.friMobHeaderimagename !== null &&
                    vmodel1.friMobHeaderimagename !== ''
                  "
                  label="Replace"
                  class="replace-button"
                  @click="replaceFileMobile"
                  icon="fa fa-undo"
                />
                <PrimeButton
                  v-if="
                    !cropperIsActiveMaxWidMob &&
                    vmodel1.friMobHeaderimagename !== null &&
                    vmodel1.friMobHeaderimagename !== ''
                  "
                  label="Clear"
                  class="clear-button ml-2"
                  @click="clearImageMobile"
                  icon="fa fa-refresh"
                />
                <PrimeButton
                  v-if="
                    !cropperIsActiveMaxWidMob &&
                    vmodel1.friMobHeaderimagename !== null &&
                    vmodel1.friMobHeaderimagename !== ''
                  "
                  label="Crop"
                  class="crop-button ml-2"
                  @click="cropImageMaxMobile"
                  icon="fa fa-refresh"
                />
                <cropper
                  v-if="cropperIsActiveMaxWidMob"
                  class="imagefit"
                  :src="vmodel1.friMobHeaderimagepath"
                  :auto-zoom="true"
                  ref="cropperComponent5"
                />
              </div>
              <div class="mt-3 mb-2">
                <PrimeButton
                  v-if="cropperIsActiveMaxWidMob"
                  label="Clear"
                  class="clear-button mt-2"
                  @click="closeCropperMaxWidMob"
                  icon="fa fa-refresh"
                />
                <PrimeButton
                  v-if="cropperIsActiveMaxWidMob"
                  label="Submit"
                  class="submit-button mt-2 ml-2"
                  @click="captureCroppedImageMaxWidMob"
                  icon="fa fa-check"
                />
              </div>
              <!-- <FileUpload
                ref="photo"
                name="photo"
                accept=".png, .jpg,.jpeg,.gif"
                @select="onAdvancedUpload($event)"
                v-show="false"
                :aria-describedby="`photo-help`"
              />-->
            </div>
          </div>
        </div>
        <!-- Mobile End -->

        <!-- Desktop Side -->

        <div
          class="grid"
          v-if="
            selectedImgType === 'imgarchive' &&
            displayimgwidget &&
            selectedDeviceType == 'desktop'
          "
        >
          <div
            :class="
              vmodel1.friHeaderimagepath == null ||
              vmodel1.friHeaderimagepath === ''
                ? 'field col-12 photo-container1'
                : 'field col-12 photo-container'
            "
          >
            <div
              :class="
                vmodel1.friHeaderimagepath === null ||
                vmodel1.friHeaderimagepath === ''
                  ? 'photo-sectionimg cursor-pointer'
                  : 'photo-section cursor-pointer'
              "
            >
              <div v-if="!cropperIsActiveMaxWidDesk">
                <img
                  v-if="
                    vmodel1.friHeaderimagepath !== '' &&
                    vmodel1.friHeaderimagepath !== null
                  "
                  :src="vmodel1.friHeaderimagepath"
                  alt
                  class="imagefit"
                />
              </div>
              <FileUpload
                type="file"
                id="fileiddesktop"
                ref="filedesktop"
                accept=".jpeg, .jpg, .gif, .png, .bmp, .tiff"
                @select="handleFileUploadDesktop($event)"
                v-show="false"
                :aria-describedby="`photo-help`"
              />
              <div
                v-if="
                  !cropperIsActiveMaxWidDesk &&
                  (vmodel1.friHeaderimagename == null ||
                    vmodel1.friHeaderimagename == '')
                "
                class="upload-icon"
              ></div>
              <span
                v-if="
                  !cropperIsActiveMaxWidDesk &&
                  (vmodel1.friHeaderimagename == null ||
                    vmodel1.friHeaderimagename == '')
                "
              >{{ staticData.settings.dropImg }}</span>
              <PrimeButton
                v-if="
                  !cropperIsActiveMaxWidDesk &&
                  (vmodel1.friHeaderimagename == null ||
                    vmodel1.friHeaderimagename == '')
                "
                label="Browse"
                class="browse-btn"
                icon="pi pi-folder-open"
                @click="openFileUploadDesktop"
              />
              <div class="mt-2">
                <PrimeButton
                  v-if="
                    !cropperIsActiveMaxWidDesk &&
                    vmodel1.friHeaderimagename !== null &&
                    vmodel1.friHeaderimagename !== ''
                  "
                  label="Replace"
                  class="replace-button"
                  @click="replaceFileDesktop"
                  icon="fa fa-undo"
                />
                <PrimeButton
                  v-if="
                    !cropperIsActiveMaxWidDesk &&
                    vmodel1.friHeaderimagename !== null &&
                    vmodel1.friHeaderimagename !== ''
                  "
                  label="Clear"
                  class="clear-button ml-2"
                  @click="clearImageDesktop()"
                  icon="fa fa-refresh"
                />
                <PrimeButton
                  v-if="
                    !cropperIsActiveMaxWidDesk &&
                    vmodel1.friHeaderimagename !== null &&
                    vmodel1.friHeaderimagename !== ''
                  "
                  label="Crop"
                  class="crop-button ml-2"
                  @click="cropImageMaxDesktop()"
                  icon="fa fa-crop"
                />

                <cropper
                  v-if="cropperIsActiveMaxWidDesk"
                  class="imagefit"
                  :src="vmodel1.friHeaderimagepath"
                  :auto-zoom="true"
                  ref="cropperComponent6"
                />
              </div>
              <div class="mt-3 mb-2">
                <PrimeButton
                  v-if="cropperIsActiveMaxWidDesk"
                  label="Clear"
                  class="clear-button mt-2"
                  @click="closeCropperMaxWidDesk"
                  icon="fa fa-refresh"
                />
                <PrimeButton
                  v-if="cropperIsActiveMaxWidDesk"
                  label="Submit"
                  class="submit-button mt-2 ml-2"
                  @click="captureCroppedImageMaxWidDesk"
                  icon="fa fa-check"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="grid" v-if="imgurl && displayimgwidget">
          <div class="col-12 lg:col-12">
            <label
              for="minwidOffsetDesktopHor"
              class="control-label"
              :isRequiredLabel="false"
            >{{ staticData.settings.img_url }}</label>
            <InputText v-model="imgurlval" id="minwidOffsetDesktopHor" class="mt-1"></InputText>
          </div>
        </div>

        <div>
          <div class="grid col-12 mt-2">
            <span class="general-settings-text">
              {{
              staticData.settings.layout
              }}
            </span>
          </div>

          <div class="grid">
            <div class="col-12">
              <div class="border-box">
                <PrimeButton
                  label="Image to the left"
                  class="rwd-btn"
                  @click="selectWidgetType('text')"
                  :class="{ 'active-btn': selectedWidgetType === 'text' }"
                  id="text"
                ></PrimeButton>

                <PrimeButton
                  label="Image to the right"
                  class="rwd-btn1"
                  @click="selectWidgetType('image')"
                  :class="{ 'active-btn': selectedWidgetType === 'image' }"
                  id="img"
                ></PrimeButton>
              </div>
            </div>
          </div>
        </div>

        <div class="grid mt-2">
          <div class="col-12 lg:col-11">
            <span class="general-settings-text">
              {{
              staticData.settings.img_border
              }}
            </span>
          </div>
          <div class="col-12 lg:col-1">
            <label>
              <div class="toggle-button toggleblock-btn">
                <span
                  :class="{
                    'toggle-on': imgBorder,
                    'toggle-off': !imgBorder,
                  }"
                  @click="imgBorder = !imgBorder"
                ></span>
              </div>
            </label>
          </div>
        </div>

        <div class="grid">
          <div class="col-12 lg:col-12 py-0">
            <label
              class="control-label"
              for="friCheckoutWelcomeTitle-tooltip"
              v-tooltip="lmodel.friCheckoutWelcomeExplainationToolTip"
            >{{ lmodel.friCheckoutWelcomeExplaination }}</label>
            <InputRequiredTextArea
              v-model="vmodel1.friendCouponScreenBodySmall"
              id="FriendCouponScreenBodySmall"
              class="mt-1"
            ></InputRequiredTextArea>
          </div>
          <div class="col-12 lg:col-12 py-0">
            <label
              class="control-label"
              for="friCheckoutWelcomeTitle-tooltip"
              v-tooltip="lmodel.friCheckoutWelcomeTermsToolTip"
            >{{ lmodel.friCheckoutWelcomeTerms }}</label>
            <InputRequiredTextArea
              v-model="vmodel1.friendCouponScreenTerms"
              id="FriendCouponScreenTerms"
              :placeholder="lmodel.friCheckoutWelcomeTermsPlaceholder"
              class="mt-1"
            ></InputRequiredTextArea>
          </div>
        </div>

        <div class="grid mt-2">
          <div class="col-12">
            <span class="general-settings-text">{{ staticData.settings.info_collection }}</span>
          </div>
        </div>

        <div class="grid" style="align-items: center">
          <div class="col-12 lg:col-11">
            <label
              for="emailText"
              class="general-settings-textlabel"
              v-tooltip="lmodel.friHideOptinFriendToolTip"
            >{{ lmodel.friHideOptinFriend }}</label>
          </div>
          <div class="col-12 lg:col-1">
            <div class="toggle-button toggleblock-btn">
              <ToggleButton
                v-model="vmodel1.friendHideOptinFriend"
                onIcon="toggle-on"
                offIcon="toggle-off"
                class="toggle-btn"
                @change="
                  vmodel1.friendHideOptinFriend == true
                    ? [
                        (vmodel1.friendIsFriendRequireOptIn = false),
                        (vmodel1.friRequireconsent = true),
                        (vmodel1.frirevfcc = false),
                        (vmodel1.friEnableConsents = false),
                        (vmodel1.friEnableSingleSelectOptions = true),
                        (vmodel1.friEnableCustomTextField = false),
                        (vmodel1.friBirthdayTitle = false),
                        (vmodel1.friEnableBirthday = false),
                        (vmodel1.FriIsRequireFriFNameLName = false),
                        (vmodel1.friendIsRequireFriendName = false),
                        (vmodel1.friShowPersonalNumber = false),
                        (vmodel1.friShowPhoneNumber = false),
                        (vmodel1.friEmailText = false),
                        (vmodel1.friShowEmail = false),
                      ]
                    : (vmodel1.friShowEmail = true),
                    (vmodel1.friEnableBirthday = true)
                "
              />
              <!-- <span
                  :class="{
                    'toggle-on': hideOptInFrd,
                    'toggle-off': !hideOptInFrd,
                  }"
                  @click="toggleHideoptfrd()"
              ></span>-->
            </div>
          </div>
        </div>
        <div class="grid" style="align-items: center">
          <div class="col-12 lg:col-11">
            <label
              for="emailText"
              class="general-settings-textlabel"
              v-tooltip="lmodel.friShowEmailToolTip"
            >{{ lmodel.friShowEmail }}</label>
          </div>
          <div class="col-12 lg:col-1">
            <div class="toggle-button toggleblock-btn">
              <!-- <span
                  :class="{
                    'toggle-on': emailButton,
                    'toggle-off': !emailButton,
                  }"
                  @click="emailButton = !emailButton"
              ></span>-->
              <ToggleButton
                v-model="vmodel1.friShowEmail"
                onIcon="toggle-on"
                offIcon="toggle-off"
                class="toggle-btn"
                @change="showEmailval()"
              />
            </div>
          </div>
        </div>

        <div class="grid mb-1">
          <div class="col-12 lg:col-6 py-0" v-if="vmodel1.friShowEmail">
            <label
              for="emailText-tooltip"
              class="control-label"
              :isRequiredLabel="false"
              v-tooltip="lmodel.friEmailTextToolTip"
            >{{ lmodel.friEmailText }}</label>
            <InputRequiredText
              v-model="vmodel1.friEmailText"
              type="text"
              id="EmailTitle"
              :placeholder="lmodel.friEmailTextPlaceholder"
            ></InputRequiredText>
          </div>
          <div class="col-12 lg:col-6 py-0" v-if="vmodel1.friShowEmail"></div>
        </div>

        <div class="grid" style="align-items: center">
          <div class="col-12 lg:col-11">
            <label
              for="phoneNumber"
              class="general-settings-textlabel"
              v-tooltip="lmodel.friendShowPhoneNumberToolTip"
            >{{ lmodel.friShowPhoneNumber }}</label>
          </div>
          <div class="col-12 lg:col-1">
            <div class="toggle-button toggleblock-btn">
              <ToggleButton
                v-model="vmodel1.friShowPhoneNumber"
                onIcon="toggle-on"
                offIcon="toggle-off"
                class="toggle-btn"
                @change="showEmailval()"
              />
              <!-- <span
                  :class="{
                    'toggle-on': phoneNumber,
                    'toggle-off': !phoneNumber,
                  }"
                  @click="phoneNumber = !phoneNumber"
              ></span>-->
            </div>
          </div>
        </div>

        <div class="grid" style="align-items: center">
          <div class="col-12 lg:col-11">
            <label
              for="personalNumber"
              class="general-settings-textlabel"
              v-tooltip="lmodel.friendShowPersonalNumberToolTip"
            >{{ lmodel.friShowPersonalNumber }}</label>
          </div>
          <div class="col-12 lg:col-1">
            <!-- <label> -->
            <div class="toggle-button toggleblock-btn">
              <!-- <span
                  :class="{
                    'toggle-on': personNumber,
                    'toggle-off': !personNumber,
                  }"
                  @click="personNumber = !personNumber"
              ></span>-->
              <ToggleButton
                v-model="vmodel1.friShowPersonalNumber"
                onIcon="toggle-on"
                offIcon="toggle-off"
                class="toggle-btn"
                @change="showEmailval()"
              />
            </div>
            <!-- </label> -->
          </div>
        </div>

        <div class="grid" style="align-items: center">
          <div class="col-12 lg:col-11">
            <label
              for="fullName"
              class="general-settings-textlabel"
              v-tooltip="lmodel.friNameRequiredToolTip"
            >{{ lmodel.friNameRequired }}</label>
          </div>
          <div class="col-12 lg:col-1">
            <div class="toggle-button toggleblock-btn">
              <ToggleButton
                v-model="vmodel1.friendIsRequireFriendName"
                onIcon="toggle-on"
                offIcon="toggle-off"
                class="toggle-btn"
                @change="
                  if (vmodel1.friendIsRequireFriendName == true) {
                    vmodel1.FriIsRequireFriFNameLName = false;
                  }
                "
              />
              <!-- <span
                  :class="{
                    'toggle-on': fullName,
                    'toggle-off': !fullName,
                  }"
                  @click="togglefrdFullName"
              ></span>-->
            </div>
          </div>
        </div>

        <div class="grid" style="align-items: center">
          <div class="col-12 lg:col-11">
            <label
              for="fNameLName"
              class="general-settings-textlabel"
              v-tooltip="lmodel.friFNameLNameRequiredToolTip"
            >{{ lmodel.friFNameLNameRequired }}</label>
          </div>
          <div class="col-12 lg:col-1">
            <div class="toggle-button toggleblock-btn">
              <ToggleButton
                v-model="vmodel1.FriIsRequireFriFNameLName"
                onIcon="toggle-on"
                offIcon="toggle-off"
                class="toggle-btn"
                @change="
                  if (vmodel1.FriIsRequireFriFNameLName == true) {
                    vmodel1.friendIsRequireFriendName = false;
                  }
                "
              />
              <!-- <span
                  :class="{
                    'toggle-on': frdfNameLName,
                    'toggle-off': !frdfNameLName,
                  }"
                  @click="togglefrdFNameLName"
              ></span>-->
            </div>
          </div>
        </div>

        <div class="grid" style="align-items: center">
          <div class="col-12 lg:col-11" v-tooltip="lmodel.friEnableBirthdayToolTip">
            <span class="general-settings-textlabel">
              {{
              lmodel.friEnableBirthday
              }}
            </span>
          </div>
          <div class="col-12 lg:col-1">
            <div class="toggle-button toggleblock-btn">
              <ToggleButton
                v-model="vmodel1.friEnableBirthday"
                onIcon="toggle-on"
                offIcon="toggle-off"
                class="toggle-btn"
              />
              <!-- <span
                  :class="{
                    'toggle-on': birthdayBtn,
                    'toggle-off': !birthdayBtn,
                  }"
                  @click="birthdayBtn = !birthdayBtn"
              ></span>-->
            </div>
          </div>
        </div>

        <div class="grid mb-1">
          <div class="col-12 lg:col-6 py-0" v-if="vmodel1.friEnableBirthday">
            <label
              v-tooltip="lmodel.friBirthdayTitleToolTip"
              for="birthdayTitle-tooltip"
              class="control-label"
              :isRequiredLabel="false"
            >{{ lmodel.friBirthdayTitle }}</label>
            <InputRequiredText
              v-model="vmodel1.friBirthdayTitle"
              type="text"
              id="BirthdayTitle"
              :placeholder="lmodel.friBirthdayTitlePlaceholder"
              class="birthday-text"
            ></InputRequiredText>
          </div>
          <div class="col-12 lg:col-6 py-0" v-if="vmodel1.friEnableBirthday"></div>
        </div>

        <div class="grid" style="align-items: center">
          <div class="col-12 lg:col-11">
            <label
              for="phoneNumber"
              class="general-settings-textlabel"
              v-tooltip="lmodel.friEnableCustomTextFieldToolTip"
            >{{ lmodel.friEnableCustomTextField }}</label>
          </div>
          <div class="col-12 lg:col-1">
            <div class="toggle-button toggleblock-btn">
              <ToggleButton
                v-model="vmodel1.friEnableCustomTextField"
                onIcon="toggle-on"
                offIcon="toggle-off"
                class="toggle-btn"
              />
              <!-- <span
                  :class="{
                    'toggle-on': custom_field,
                    'toggle-off': !custom_field,
                  }"
                  @click="custom_field = !custom_field"
              ></span>-->
            </div>
          </div>

          <div class="col-12 lg:col-6 py-0" v-if="vmodel1.friEnableCustomTextField">
            <label
              v-tooltip="lmodel.friCustomTextFieldTitleToolTip"
              for="customTextFieldTitle-tooltip"
              class="control-label"
              :isRequiredLabel="false"
            >{{ lmodel.friCustomTextFieldTitle }}</label>
            <InputRequiredText
              :validation="valmodel.friCustomTextFieldLabel"
              v-model="vmodel1.friCustomTextFieldLabel"
              id="friCustomTextFieldLabel12"
              PropName="Custom Text Field Title"
              class="w-full"
              :placeholder="lmodel.friCustomTextFieldTitlePlaceholder"
            ></InputRequiredText>
          </div>
          <div class="col-12 lg:col-6 py-0" v-if="vmodel1.friEnableCustomTextField">
            <label
              v-tooltip="lmodel.friEnableCustomTextFieldToolTip"
              for="customTextField-tooltip"
              class="control-label"
              :isRequiredLabel="false"
            >{{ lmodel.friCustomTextField }}</label>
            <InputRequiredText
              :validation="valmodel.friCustomTextField"
              v-model="vmodel1.friCustomTextField"
              id="friCustomTextField12"
              PropName="Custom Text Field"
              class="w-full"
              :placeholder="lmodel.friCustomTextFieldPlaceholder"
            ></InputRequiredText>
          </div>
        </div>

        <div class="grid" style="align-items: center">
          <div class="col-12 lg:col-11">
            <label for="electOptions" class="general-settings-textlabel">
              {{
              staticData.settings.choice
              }}
            </label>
          </div>

          <div class="col-12 lg:col-1">
            <div class="toggle-button toggleblock-btn">
              <ToggleButton
                v-model="vmodel1.friEnableSingleSelectOptions"
                onIcon="toggle-on"
                offIcon="toggle-off"
                class="toggle-btn"
              />
              <!-- <span
                  :class="{
                    'toggle-on': choicesBtn,
                    'toggle-off': !choicesBtn,
                  }"
                  @click="choicesBtn = !choicesBtn"
              ></span>-->
            </div>
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-12" v-if="vmodel1.friEnableSingleSelectOptions">
            <PrimeButton
              class="btn-add-select"
              @click="addSingleSelectOption"
              :disabled="vmodel1.friEnableSelectOption.length >= 4"
              tabindex="-1"
              icon="pi pi-plus"
              label="New question"
            ></PrimeButton>
          </div>
        </div>
        <div class="grid col-12" v-if="vmodel1.friEnableSingleSelectOptions">
          <div class="col-12 lg:col-12">
            <label class="general-settings-textnew">{{ staticData.settings.question }} {{ 1 }}</label>
          </div>

          <div class="col-12 lg:col-6">
            <label for="electOptions" class="general-settings-text">
              {{
              staticData.settings.que
              }}
            </label>
            <InputRequiredText
              v-model="
                  vmodel1.friCustomTagsTitle
                "
              class="mt-2"
              autocomplete="nope"
              id="title"
              :placeholder="lmodel.friCustomTagsTitlePlaceholder"
            />
          </div>
          <div class="col-12 lg:col-6">
            <label for="electOptions" class="general-settings-text">
              {{
              lmodel.friCustomTextField
              }}
            </label>
            <InputRequiredText
              :validation="valmodel.friCustomFieldName"
              v-model="
                  vmodel1.friCustomFieldName
                "
              class="mt-2"
              :PropName="lmodel.friCustomTextField"
              autocomplete="nope"
              id="title"
              :placeholder="lmodel.friCustomTextFieldPlaceholder"
              @update:modelValue="validateCustomTag()"
            />
          </div>
          <!-- Toggle btn -->

          <!-- Req Ans -->

          <div class="col-3 toggle-button toggleblock-btn">
            <ToggleButton
              v-model="vmodel1.friRequireAns"
              onIcon="toggle-on"
              offIcon="toggle-off"
              class="toggle-btn"
            />
            <label
              for="electOptions"
              class="general-settings-textnew ml-2"
            >{{ staticData.settings.req_ans }}</label>
          </div>

          <!-- Drop Down -->
          <div class="col-3 toggle-button toggleblock-btn">
            <ToggleButton
              v-model="vmodel1.friDropdown"
              onIcon="toggle-on"
              offIcon="toggle-off"
              class="toggle-btn"
            />
            <label
              for="electOptions"
              class="general-settings-textnew ml-2"
            >{{ staticData.settings.dropdown }}</label>
          </div>

          <div class="col-3 toggle-button toggleblock-btn">
            <ToggleButton
              v-model="vmodel1.friMultiAns"
              onIcon="toggle-on"
              offIcon="toggle-off"
              class="toggle-btn"
            />
            <label
              for="electOptions"
              class="general-settings-textnew ml-2"
            >{{ staticData.settings.multiple_ans }}</label>
          </div>
        </div>

        <div
          id="option-list"
          class="option-list grid col-12"
          style="margin-top: -17px"
          v-show="vmodel1.friEnableSingleSelectOptions"
        >
          <div v-for="(ena, index) in vmodel.friCustomtags" class="grid col-12" :key="index">
            <div class="col-12 lg:col-6">
              <label
                class="general-settings-textnew"
              >{{ staticData.settings.option }} {{ index + 1 }}</label>
            </div>
            <div class="col-12 lg:col-6" style="display: flex; justify-content: flex-end">
              <PrimeButton
                id="cancelbtn"
                name="Cancel"
                icon="pi pi-trash"
                @click="removeSingleComponentSelectFrd(index)"
                label="Remove option"
                class="btn-danger"
              />
            </div>
            <div
              :class="
              index > 0
                ? 'col-12 lg:' +
                  (vmodel1.friCustomtagstype == 1 || vmodel1.friCustomtagstype == 3
                    ? 'col-6'
                    : 'col-6')
                : 'col-12 lg:' +
                  (vmodel1.friCustomtagstype == 1 || vmodel1.friCustomtagstype == 3
                    ? 'col-6'
                    : 'col-6')
            "
            >
              <label
                v-tooltip="lmodel.friEnableLabelToolTip"
                tooltipvalueFor="friEnableLabel-tooltip"
                labelclass="control-label"
              >{{lmodel.friEnableLabel}}</label>
              <InputRequiredText
                v-model="vmodel1.friCustomtags[index].label"
                :id="'Lable' + index"
                :placeholder="lmodel.friEnableLabelPlaceholder"
                @update:modelValue="validateCustomTag()"
                :class="{
                'p-invalid':
                  frdcustomErrorMessage[index] && frdcustomErrorMessage[index].label,
              }"
                :PropName="lmodel.friEnableLabel"
              ></InputRequiredText>
              <span
                v-if="
                frdcustomErrorMessage &&
                frdcustomErrorMessage[index] &&
                frdcustomErrorMessage[index].label
              "
                :id="`label ${index}-help`"
                class="p-error text-left mt-2"
              >{{ lmodel.friEnableLabel + " is Required" }}</span>
            </div>
            <div
              :class="
              index > 0
                ? 'col-12 lg:' +
                  (vmodel1.friCustomtagstype == 1 || vmodel1.friCustomtagstype == 3
                    ? 'col-6'
                    : 'col-6')
                : 'col-12 lg:' +
                  (vmodel1.friCustomtagstype == 1 || vmodel1.friCustomtagstype == 3
                    ? 'col-6'
                    : 'col-6')
            "
            >
              <label
                v-tooltip="lmodel.friEnableTagToolTip"
                tooltipvalueFor="friEnableTag-tooltip"
                labelclass="control-label"
              >{{lmodel.friEnableTag}}</label>
              <InputRequiredText
                v-model="vmodel1.friCustomtags[index].tag"
                :id="'Tag' + index"
                :placeholder="lmodel.friEnableTagPlaceholder"
                :IsCustomTagForRule="true"
                @update:modelValue="validateCustomTag()"
                :class="{
                'p-invalid':
                  frdcustomErrorMessage[index] && frdcustomErrorMessage[index].tag,
              }"
                :PropName="lmodel.friEnableTag"
              ></InputRequiredText>

              <span
                v-if="
                frdcustomErrorMessage &&
                frdcustomErrorMessage[index] &&
                frdcustomErrorMessage[index].tag
              "
                :id="`Tag ${index}-help`"
                class="p-error text-left mt-2"
              >{{ lmodel.friEnableTag + " is Required" }}</span>
            </div>
            <!-- Open Next Input Field -->
            <div
              class="form-group"
              :class="
              index > 0
                ? 'col-12 lg:' +
                  (vmodel1.friCustomtagstype == 1 || vmodel1.friCustomtagstype == 3
                    ? 'col-6'
                    : 'col-6')
                : 'col-12 lg:' +
                  (vmodel1.friCustomtagstype == 1 || vmodel1.friCustomtagstype == 3
                    ? 'col-6'
                    : 'col-6')
            "
              v-show="
              !(vmodel1.friCustomtagstype == 1) && !(vmodel1.friCustomtagstype == 3)
            "
            >
              <label
                v-tooltip="lmodel.friEnableLabelToolTip"
                tooltipvalueFor="riEnableLabe-tooltip"
                labelclass="control-label"
              >{{lmodel.friOpnNextDealByTag}}</label>
              <InputRequiredText
                v-model="vmodel1.friCustomtags[index].opnNextDealByTag"
                :id="'opnNextDealByTag' + opnNextDealByTag"
                :IsCustomTagForRule="true"
                :disabled="
                !vmodel1.friCustomtags[index].tag ||
                vmodel1.friCustomtags[index].tag.trim() === '' ||
                !vmodel1.friCustomtags[index].label ||
                vmodel1.friCustomtags[index].label.trim() === '' ||
                (!!vmodel1.friCustomtags[index].redirectToUrl &&
                  vmodel1.friCustomtags[index].redirectToUrl.trim() !== '')
              "
              ></InputRequiredText>
            </div>

            <!-- Redirect URL Input Field -->
            <div
              class="form-group"
              :class="index > 0 ? 'col-12 lg:col-6' : 'col-12 lg:col-6'"
              v-show="
              !(vmodel1.friCustomtagstype == 1) && !(vmodel1.friCustomtagstype == 3)
            "
            >
              <label
                v-tooltip="lmodel.friEnableLabelToolTip"
                tooltipvalueFor="friEnableLabel-tooltip"
                labelclass="control-label"
              >{{lmodel.ambRedirectToUrl}}</label>
              <InputRequiredText
                v-model="vmodel1.friCustomtags[index].redirectToUrl"
                :id="'redirectToUrl' + redirectToUrl"
                :IsCustomTagForRule="true"
                :disabled="
                !vmodel1.friCustomtags[index].tag ||
                vmodel1.friCustomtags[index].tag.trim() === '' ||
                !vmodel1.friCustomtags[index].label ||
                vmodel1.friCustomtags[index].label.trim() === '' ||
                (!!vmodel1.friCustomtags[index].opnNextDealByTag &&
                  vmodel1.friCustomtags[index].opnNextDealByTag.trim() !== '')
              "
              ></InputRequiredText>
            </div>
          </div>
          <div
            class="col-12 lg:col-12"
            v-if="vmodel1.friEnableSingleSelectOptions"
            style="display: flex; justify-content: center"
          >
            <PrimeButton
              class="btn-add-select"
              icon="pi pi-plus"
              @click="addComponentSingleSelectFrd(index)"
              type="button"
              tabindex="-1"
              label="Add new option"
            ></PrimeButton>
          </div>
        </div>

        <div
          v-show="
            vmodel1.friEnableSingleSelectOptions &&
            vmodel1.friEnableSelectOption
          "
        >
          <div
            v-for="(ena, subindex) in vmodel1.friEnableSelectOption"
            class="grid col-12"
            :key="subindex"
          >
            <div class="col-12 lg:col-6">
              <label
                class="general-settings-textnew"
              >{{ staticData.settings.question }} {{ subindex + 1 }}</label>
            </div>
            <div class="col-12 lg:col-6">
              <PrimeButton
                class="btn-danger"
                style="margin-left: auto; display: flex"
                @click="removeaddSingleSelectOption(subindex)"
                type="button"
                tabindex="-1"
                icon="pi pi-trash"
                label="Remove question"
              ></PrimeButton>
            </div>
            <div class="col-12 lg:col-6">
              <label for="electOptions" class="general-settings-text">
                {{
                staticData.settings.que
                }}
              </label>
              <InputRequiredText
                v-model="
                  vmodel1.friEnableSelectOption[subindex].customtagstitle
                "
                class="mt-2"
                autocomplete="nope"
                id="title"
                :placeholder="lmodel.friCustomTextFieldTitlePlaceholder"
              />
            </div>
            <div class="col-12 lg:col-6">
              <label for="electOptions" class="general-settings-text">
                {{
                lmodel.friCustomTextField
                }}
              </label>
              <InputRequiredText
                :class="{ 'p-invalid': frdErrorMessage[subindex] }"
                v-model="
                  vmodel1.friEnableSelectOption[subindex].customfieldname
                "
                class="mt-2"
                PropName="Custom Text Field"
                autocomplete="nope"
                id="title"
                @update:modelValue="validateCustomTag()"
                :placeholder="lmodel.friCustomTextFieldPlaceholder"
              />
              <span
                v-if="frdErrorMessage[subindex]"
                class="p-error"
              >The {{ lmodel.friCustomTextField }} is required</span>
            </div>

            <!-- Toggle btn -->
            <div
              class="grid col-12 lg:col-12 horizontal-align"
              v-show="vmodel1.friEnableSingleSelectOptions"
            >
              <!-- Req Ans -->

              <div class="col-3 toggle-button toggleblock-btn">
                <span
                  :class="{
                    'toggle-on new-tgbtn': reqAns,
                    'toggle-off new-tgbtn': !reqAns,
                  }"
                  @click="reqAns = !reqAns"
                ></span>
                <label
                  for="electOptions"
                  class="general-settings-textlabel ml-2"
                >{{ staticData.settings.req_ans }}</label>
              </div>

              <!-- Drop Down -->
              <div class="col-3 toggle-button toggleblock-btn">
                <span
                  :class="{
                    'toggle-on new-tgbtn': dropDownBtn,
                    'toggle-off new-tgbtn': !dropDownBtn,
                  }"
                  @click="dropDownBtn = !dropDownBtn"
                ></span>
                <label
                  for="electOptions"
                  class="general-settings-textlabel ml-2"
                >{{ staticData.settings.dropdown }}</label>
              </div>

              <div class="col-3 toggle-button toggleblock-btn">
                <span
                  :class="{
                    'toggle-on new-tgbtn': multipleAns,
                    'toggle-off new-tgbtn': !multipleAns,
                  }"
                  @click="multipleAns = !multipleAns"
                ></span>
                <label
                  for="electOptions"
                  class="general-settings-textlabel ml-2"
                >{{ staticData.settings.multiple_ans }}</label>
              </div>
            </div>

            <!-- Options -->
            <div
              v-for="(ena, index) in vmodel.friEnableSelectOption[subindex]
                .customtags"
              class="grid col-12"
              :key="index"
            >
              <div class="col-12 lg:col-6">
                <label
                  class="general-settings-textlabel"
                >{{ staticData.settings.option }} {{ index + 1 }}</label>
              </div>
              <div class="col-12 lg:col-6" style="display: flex; justify-content: flex-end">
                <PrimeButton
                  id="cancelbtn"
                  name="Cancel"
                  icon="pi pi-trash"
                  @click="removeComponentSelect(subindex, index)"
                  label="Remove option"
                  class="btn-danger"
                />
              </div>
              <div class="col-12 lg:col-6 py-0">
                <label class="control-label">{{ lmodel.friEnableLabel }}</label>
                <InputRequiredText
                  v-model="
                    vmodel1.friEnableSelectOption[subindex].customtags[index]
                      .label
                  "
                  :class="{
                    'p-invalid':
                      frdSelectOptErrorMessage[subindex] &&
                      frdSelectOptErrorMessage[subindex][index] &&
                      frdSelectOptErrorMessage[subindex][index].label,
                  }"
                  :id="'Lable' + index"
                  :PropName="lmodel.friEnableLabel"
                  @update:modelValue="updateCustomTag(subindex)"
                ></InputRequiredText>
                <span
                  v-if="
                    frdSelectOptErrorMessage &&
                    frdSelectOptErrorMessage[subindex] &&
                    frdSelectOptErrorMessage[subindex][index] &&
                    frdSelectOptErrorMessage[subindex][index].label
                  "
                  :id="`label ${index}-help`"
                  class="p-error text-left mt-2"
                >{{ lmodel.friEnableLabel + " is Required" }}</span>
              </div>
              <div class="col-12 lg:col-6 py-0">
                <label class="control-label">{{ lmodel.friEnableTag }}</label>
                <InputRequiredText
                  v-model="
                    vmodel1.friEnableSelectOption[subindex].customtags[index]
                      .tag
                  "
                  :id="'Tag' + index"
                  :PropName="lmodel.friEnableTag"
                  :class="{
                    'p-invalid':
                      frdSelectOptErrorMessage[subindex] &&
                      frdSelectOptErrorMessage[subindex][index] &&
                      frdSelectOptErrorMessage[subindex][index].tag,
                  }"
                  @update:modelValue="updateCustomTag(subindex)"
                ></InputRequiredText>
                <span
                  v-if="
                    frdSelectOptErrorMessage &&
                    frdSelectOptErrorMessage[subindex] &&
                    frdSelectOptErrorMessage[subindex][index] &&
                    frdSelectOptErrorMessage[subindex][index].tag
                  "
                  :id="`tag ${index}-help`"
                  class="p-error text-left mt-2"
                >{{ lmodel.friEnableTag + " is Required" }}</span>
              </div>
              <div class="col-12 lg:col-6 form-group py-0" v-if="!multipleAns">
                <label class="control-label">{{ lmodel.friOpnNextDealByTag }}</label>
                <InputRequiredText
                  v-model="
                    vmodel1.friEnableSelectOption[subindex].customtags[index]
                      .opnNextDealByTag
                  "
                  :id="'opnNextDealByTag' + opnNextDealByTag"
                  :IsCustomTagForRule="true"
                  :disabled="
                    !vmodel1.friEnableSelectOption[subindex].customtags[index]
                      .tag ||
                    vmodel1.friEnableSelectOption[subindex].customtags[
                      index
                    ].tag.trim() === '' ||
                    !vmodel1.friEnableSelectOption[subindex].customtags[index]
                      .label ||
                    vmodel1.friEnableSelectOption[subindex].customtags[
                      index
                    ].label.trim() === '' ||
                    (!!vmodel1.friEnableSelectOption[subindex].customtags[index]
                      .redirectToUrl &&
                      vmodel1.friEnableSelectOption[subindex].customtags[
                        index
                      ].redirectToUrl.trim() !== '')
                  "
                ></InputRequiredText>
              </div>
              <div class="col-12 lg:col-6 form-group py-0" v-if="!multipleAns">
                <label class="control-label">{{ lmodel.friRedirectToUrl }}</label>
                <InputRequiredText
                  v-model="
                    vmodel1.friEnableSelectOption[subindex].customtags[index]
                      .redirectToUrl
                  "
                  :id="'redirectToUrl' + redirectToUrl"
                  :IsCustomTagForRule="true"
                  :disabled="
                    !vmodel1.friEnableSelectOption[subindex].customtags[index]
                      .tag ||
                    vmodel1.friEnableSelectOption[subindex].customtags[
                      index
                    ].tag.trim() === '' ||
                    !vmodel1.friEnableSelectOption[subindex].customtags[index]
                      .label ||
                    vmodel1.friEnableSelectOption[subindex].customtags[
                      index
                    ].label.trim() === '' ||
                    (!!vmodel1.friEnableSelectOption[subindex].customtags[index]
                      .opnNextDealByTag &&
                      vmodel1.friEnableSelectOption[subindex].customtags[
                        index
                      ].opnNextDealByTag.trim() !== '')
                  "
                ></InputRequiredText>
              </div>
            </div>
            <div
              class="col-12 lg:col-12"
              v-if="vmodel1.friEnableSelectOption"
              style="display: flex; justify-content: center"
            >
              <PrimeButton
                class="btn-add-select"
                icon="pi pi-plus"
                @click="addComponentSelect(subindex)"
                type="button"
                tabindex="-1"
                label="Add new option"
              ></PrimeButton>
            </div>
            <!-- </div> -->
          </div>
        </div>

        <!-- friend concents -->
        <div class="grid" style="align-items: center">
          <div class="col-12 lg:col-11">
            <label
              for="electOptions"
              class="general-settings-textlabel"
              v-tooltip="lmodel.FriEnableConsentsToolTip"
            >{{ lmodel.friEnableConsents }}</label>
          </div>

          <div class="col-12 lg:col-1">
            <div class="toggle-button toggleblock-btn">
              <ToggleButton
                v-model="vmodel1.friEnableConsents"
                onIcon="toggle-on"
                offIcon="toggle-off"
                class="toggle-btn"
              />
              <!-- <span
                :class="{
                  'toggle-on': frienableConcents,
                  'toggle-off': !frienableConcents,
                }"
                @click="frienableConcents = !frienableConcents"
              ></span>-->
            </div>
          </div>

          <div class="grid">
            <div class="col-12 lg:col-12" v-if="vmodel1.friEnableConsents">
              <PrimeButton
                class="btn-add-select"
                icon="pi pi-plus"
                label="Add Consents"
                @click="addConsentsDropdown()"
                type="button"
                tabindex="-1"
              ></PrimeButton>
            </div>
          </div>

          <div class="col-12" v-if="isOpenDropdown || this.$route.params.id">
            <div v-for="(friConsents, index) in this.vmodel1.friConsents" :key="index">
              <div class="grid" v-if="vmodel1.friEnableConsents">
                <div class="col-12 lg:col-6">
                  <span class="general-settings-text">Select consents</span>
                </div>
                <div class="col-12 lg:col-6 py-0" style="display: flex; justify-content: flex-end">
                  <PrimeButton
                    class="btn-danger"
                    @click="removeConsentsDropdown(index)"
                    type="button"
                    tabindex="-1"
                    label="Remove Consents"
                  />
                </div>
              </div>
              <div class="grid" v-if="vmodel1.friEnableConsents">
                <div class="col-12 lg:col-6 py-0">
                  <DropDownRequire
                    v-model="friConsents.id"
                    :options="getFilteredOptions(index)"
                    id="friConsents"
                    class="mt-2 dropdown flex-grow-1"
                    optionLabel="name"
                    optionValue="value"
                    @change="updateSelected(friConsents, index)"
                  ></DropDownRequire>
                </div>
              </div>
              <div v-if="friConsents.id !== null" class="grid mt-2">
                <div class="col-12 lg:col-6">{{ getOptionText(friConsents.id) }}</div>
                <div class="col-3 toggle-button toggleblock-btn">
                  <span
                    :class="{
                      'toggle-on new-tgbtn': friConsentsReq,
                      'toggle-off new-tgbtn': !friConsentsReq,
                    }"
                    @click="friConsentsReq = !friConsentsReq"
                  ></span>
                  <label for="electOptions" class="general-settings-textnew ml-2">Required</label>
                </div>
                <div class="col-3 toggle-button toggleblock-btn">
                  <span
                    :class="{
                      'toggle-on new-tgbtn': friConsentsDefSelected,
                      'toggle-off new-tgbtn': !friConsentsDefSelected,
                    }"
                    @click="friConsentsDefSelected = !friConsentsDefSelected"
                  ></span>
                  <label for="electOptions" class="general-settings-textnew ml-2">Default selected</label>
                </div>
                <div class="col-12 lg:col-4">
                  <span>Display Text: {{ friConsents.displayText }}</span>
                </div>
                <div class="col-12 lg:col-4">
                  <span>Link Text: {{ friConsents.linkText }}</span>
                </div>
                <div class="col-12 lg:col-4">
                  <span>Condition Text: {{ friConsents.conditionText }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="grid" style="align-items: center">
          <div class="col-12 lg:col-6">
            <label for="emailVerification" class="general-settings-text">
              {{
              lmodel.frirevfcc
              }}
            </label>
          </div>
          <div class="col-12 lg:col-5"></div>
          <div class="col-12 lg:col-1">
            <div class="toggle-button toggleblock-btn">
              <ToggleButton
                v-model="vmodel1.frirevfcc"
                onIcon="toggle-on"
                offIcon="toggle-off"
                class="toggle-btn"
              />
              <!-- <span
                  :class="{
                    'toggle-on': req_email,
                    'toggle-off': !req_email,
                  }"
                  @click="req_email = !req_email"
              ></span>-->
            </div>
          </div>
        </div>

        <div class="grid col-12 mt-2">
          <span class="general-settings-text">
            {{
            staticData.settings.pos_page
            }}
          </span>
        </div>
        <div class="grid">
          <div class="col-12">
            <DropDownRequire
              :options="PositionOptions"
              id="SiteId"
              placeholder="Go to maximized view"
              optionLabel="text"
              class="drop-down-val"
              optionValue="value"
              v-model="positionSelect"
              editable
              :disabled="true"
            ></DropDownRequire>
          </div>
        </div>
        <div class="grid mt-2">
          <div class="col-12">
            <span class="text-value">{{ staticData.settings.offsetedge }}</span>
          </div>
          <div class="col-12 py-0">
            <label for="off_widget">{{ staticData.settings.vertical }}</label>
            <InputText v-model="voffset" id="voffset" class="mt-1"></InputText>
          </div>
        </div>

        <!-- Text Fields -->
        <div class="grid mt-2">
          <div class="col-12 lg:col-12">
            <span class="general-text">{{ lmodel.texts }}</span>
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-12 py-0">
            <label
              class="control-label"
              for="friCheckoutWelcomeTitle-tooltip"
            >{{ staticData.settings.heading }}</label>
            <InputRequiredTextArea
              v-model="vmodel1.friCustomerCheckoutWelcomeTitle"
              id="CustomerCheckoutWelcomeTitle"
              PropName="Widget Header"
              class="mt-1"
              :placeholder="lmodel.friCheckoutWelcomeTitlePlaceholder"
            ></InputRequiredTextArea>
          </div>
          <div class="col-12 lg:col-12 py-0">
            <label
              class="control-label"
              for="friCheckoutWelcomeTitle-tooltip"
            >{{ staticData.settings.body_text }}</label>
            <InputRequiredTextArea
              v-model="vmodel1.friCustomerCheckoutWelcomeBody"
              id="CustomerCheckoutWelcomeTitle"
              PropName="Widget Header"
              class="mt-1"
            ></InputRequiredTextArea>
          </div>
          <div class="col-12 lg:col-12 py-0">
            <label
              class="control-label"
              for="friCheckoutWelcomeTitle-tooltip"
            >{{ staticData.settings.continue_btn }}</label>
            <InputRequiredText
              v-model="cntbtnValue"
              id="CustomerCheckoutWelcomeTitle"
              PropName="Widget Header"
              class="mt-1"
            ></InputRequiredText>
          </div>
          <div class="col-12 lg:col-12 py-0">
            <label
              class="control-label"
              for="friCheckoutWelcomeTitle-tooltip"
            >{{ staticData.settings.heading_step }}</label>
            <Textarea
              v-model="vmodel1.frinotCombinedWidgetHeader"
              id="CustomerCheckoutWelcomeTitle"
              PropName="Widget Header"
              class="mt-1"
            ></Textarea>
          </div>
          <div class="col-12 lg:col-12 py-0">
            <label
              class="control-label"
              for="friCheckoutWelcomeTitle-tooltip"
            >{{ staticData.settings.body_textstep }}</label>
            <Textarea
              v-model="vmodel1.frinotCombinedWidgetBodytxt"
              id="CustomerCheckoutWelcomeTitle"
              PropName="Widget Header"
              class="mt-1"
            ></Textarea>
          </div>
        </div>
        <!-- Landing Popup-Text -->
        <div class="grid mt-2">
          <div class="col-12 lg:col-12">
            <span class="general-text">
              {{
              lmodel.friendLandingPopupButtonTextTitle
              }}
            </span>
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-6">
            <label
              for="firstSendButton"
              class="control-label"
              :isRequiredLabel="false"
              v-tooltip="lmodel.friFirstSendButtonToolTip"
            >{{ lmodel.friFirstSendButton }}</label>
            <InputText
              id="FirstSendButton"
              type="text"
              class="mt-1"
              autocomplete="off"
              v-model="vmodel1.friendFirstSendButton"
            ></InputText>
          </div>
          <div class="col-12 lg:col-6">
            <label
              for="firstCloseButton"
              class="control-label"
              :isRequiredLabel="false"
              v-tooltip="lmodel.friFirstCloseButtonToolTip"
            >{{ lmodel.friFirstCloseButton }}</label>
            <InputText
              id="FirstCloseButton"
              type="text"
              class="mt-1"
              autocomplete="off"
              v-model="vmodel1.friendFirstCloseButton"
            ></InputText>
          </div>
          <div class="col-12 lg:col-6">
            <label
              for="getYourCode"
              class="control-label"
              :isRequiredLabel="false"
              v-tooltip="lmodel.friGetYourCodeButtonToolTip"
            >{{ lmodel.friGetYourCodeButton }}</label>
            <InputText
              id="GetYourCode"
              type="text"
              class="mt-1"
              autocomplete="off"
              v-model="vmodel1.friendGetYourCodeButton"
            ></InputText>
          </div>
          <div class="col-12 lg:col-6">
            <label
              for="closeButtonAfterreward"
              class="control-label"
              :isRequiredLabel="false"
              v-tooltip="lmodel.friendCloseButtonAfterrewardToolTip"
            >{{ lmodel.friendCloseButtonAfterreward }}</label>
            <InputText
              id="CloseButtonAfterreward"
              type="text"
              class="mt-1"
              autocomplete="off"
              v-model="vmodel1.friendCloseButtonAfterreward"
            ></InputText>
          </div>
          <div class="col-12 lg:col-6">
            <label
              for="saveRemindMeButton"
              class="control-label"
              :isRequiredLabel="false"
              v-tooltip="lmodel.friSaveRemindMeButtonToolTip"
            >{{ lmodel.friSaveRemindMeButton }}</label>
            <InputText
              id="SaveRemindMeButton"
              type="text"
              class="mt-1"
              autocomplete="off"
              :placeholder="lmodel.friSaveRemindMeButtonPlaceholder"
              v-model="vmodel1.friSaveRemindMeButton"
            ></InputText>
          </div>
          <div class="col-12 lg:col-6">
            <label
              for="saveOfferForLater"
              class="control-label"
              :isRequiredLabel="false"
              v-tooltip="lmodel.friSaveOfferForLaterTextToolTip"
            >{{ lmodel.friSaveOfferForLaterText }}</label>
            <InputText
              id="SaveOfferForLater"
              type="text"
              class="mt-1"
              autocomplete="off"
              :placeholder="lmodel.friSaveOfferForLaterTextPlaceholder"
              v-model="vmodel1.friSaveOfferForLaterText"
            ></InputText>
          </div>
        </div>

        <!-- Store Policy -->

        <div class="grid mt-2">
          <div class="col-12 lg:col-12">
            <span class="general-text">
              {{
              lmodel.friendStorePolicyTitle
              }}
            </span>
          </div>
        </div>
        <div class="grid" style="align-items: center">
          <div class="col-12 lg:col-11">
            <label
              for="electOptions"
              class="general-settings-textlabel"
              v-tooltip="lmodel.friRequireOptInToolTip"
            >{{ lmodel.friRequireOptIn }}</label>
          </div>

          <div class="col-12 lg:col-1">
            <div class="toggle-button toggleblock-btn">
              <ToggleButton
                v-model="vmodel1.friendIsFriendRequireOptIn"
                onIcon="toggle-on"
                offIcon="toggle-off"
                class="toggle-btn"
              />
              <!-- <span
                  :class="{
                    'toggle-on': requireOptIn,
                    'toggle-off': !requireOptIn,
                  }"
                  @click="requireOptIn = !requireOptIn"
              ></span>-->
            </div>
          </div>
        </div>
        <div class="grid" style="align-items: center">
          <div class="col-12 lg:col-11">
            <label
              for="electOptions"
              class="general-settings-textlabel"
              v-tooltip="lmodel.friRequireconsentToolTip"
            >{{ lmodel.friRequireconsent }}</label>
          </div>

          <div class="col-12 lg:col-1">
            <div class="toggle-button toggleblock-btn">
              <ToggleButton
                v-model="vmodel1.friRequireconsent"
                onIcon="toggle-on"
                offIcon="toggle-off"
                class="toggle-btn"
              />
              <!-- <span
                  :class="{
                    'toggle-on': requireconsent,
                    'toggle-off': !requireconsent,
                  }"
                  @click="requireconsent = !requireconsent"
              ></span>-->
            </div>
          </div>
        </div>

        <div class="grid">
          <div class="col-12 lg:col-12 mt-1">
            <label
              class="control-label"
              for="friendOptInYes"
              v-tooltip="lmodel.setFriendOptInYesToolTip"
            >{{ lmodel.setFriendOptInYes }}</label>
            <Textarea v-model="vmodel1.setFriendOptInYes" id="friendOptInYes" class="mt-1"></Textarea>
          </div>
          <div class="col-12 lg:col-12 mt-1">
            <label
              class="control-label"
              for="friendOptInNo"
              v-tooltip="lmodel.setFriendOptInNoToolTip"
            >{{ lmodel.setFriendOptInNo }}</label>
            <Textarea v-model="vmodel1.setFriendOptInNo" id="friendOptInNo" class="mt-1"></Textarea>
          </div>
          <div class="col-12 lg:col-12 mt-1">
            <label
              class="control-label"
              for="termConsentText"
              v-tooltip="lmodel.friendTermConsentTextToolTip"
            >{{ lmodel.friendTermConsentText }}</label>
            <Textarea v-model="vmodel1.friendTermConsentText" id="termConsentText" class="mt-1"></Textarea>
          </div>
        </div>
        <!--Contact Integration -->
        <div class="grid mt-2">
          <div class="col-12 lg:col-12">
            <span class="general-settings-text">{{ lmodel.friCiSectionTitle }}</span>
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-6">
            <label
              class="control-label"
              v-tooltip="lmodel.friVoyadoMemberTypeToolTip"
            >{{ lmodel.friVoyadoMemberType }}</label>
            <DropDownRequire
              :options="dmodel.ambassadorFriend.voyadoMemberTypeListItems"
              id="SiteId"
              optionLabel="text"
              optionValue="value"
              class="drop-down-val"
              editable
              v-model="vmodel1.friVoyadoMemberType"
            ></DropDownRequire>
          </div>

          <div class="col-12 lg:col-6">
            <label
              for="voyadoExternalId"
              class="control-label"
              :isRequiredLabel="false"
              v-tooltip="lmodel.friVoyadoExternalIdToolTip"
            >{{ lmodel.friVoyadoExternalId }}</label>
            <InputText
              id="voyadoExternalId"
              type="text"
              class="mt-1"
              autocomplete="off"
              v-model="vmodel1.friVoyadoExternalId"
              :placeholder="lmodel.friVoyadoExternalIdPlaceholder"
            ></InputText>
          </div>
          <div class="col-12 lg:col-6">
            <label
              for="ciFieldName"
              class="control-label"
              :isRequiredLabel="false"
              v-tooltip="lmodel.friciFieldNameToolTip"
            >{{ lmodel.friciFieldName }}</label>
            <InputRequiredText
              v-model="vmodel1.friciFieldName"
              :validation="valmodel.friciFieldName"
              type="text"
              autocomplete="off"
              :PropName="lmodel.friciFieldName"
              id="friciFieldName"
              :placeholder="lmodel.friciFieldNamePlaceholder"
            />
          </div>
          <div class="col-12 lg:col-6">
            <label
              for="ciFieldValue"
              class="control-label"
              :isRequiredLabel="false"
              v-tooltip="lmodel.friciFieldValueToolTip"
            >{{ lmodel.friciFieldValue }}</label>
            <InputRequiredText
              v-model="vmodel1.friciFieldValue"
              :validation="valmodel.friciFieldValue"
              type="text"
              autocomplete="off"
              :PropName="lmodel.friciFieldValue"
              id="ciFieldValue"
              :placeholder="lmodel.friciFieldValuePlaceholder"
            />
          </div>
        </div>
      </TabPanel>
      <!-- Styling  -->
      <TabPanel header="Styling" v-if="lmodel !== null && vmodel !== null">
        <!-- Heading -->
        <div class="grid">
          <div class="col-12 lg:col-12 mt-1">
            <span class="general-settings-text">{{ staticData.styling.heading }}</span>
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-12">
            <DropDownRequire
              :options="TextOptions"
              id="SiteId"
              optionLabel="text"
              class="drop-down-val"
              optionValue="value"
              editable
              v-model="selectedOptionText"
            ></DropDownRequire>
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-12 flex">
            <div class="p-inputgroup">
              <span class="p-inputgroup-add">
                <i class="value-icon"></i>
              </span>
              <InputText id="SiteId" v-model="value" class="input-border border-icon" editable></InputText>
            </div>
            <div>
              <button @click="increaseValue" class="up-btn">
                <i class="pi pi-chevron-up ar-color"></i>
              </button>
              <button @click="decreaseValue" class="down-btn">
                <i class="pi pi-chevron-down ar-color"></i>
              </button>
            </div>
          </div>
        </div>
        <!-- Body Text -->
        <div class="grid">
          <div class="col-12 lg:col-12 mt-2">
            <span class="general-settings-text">{{ staticData.styling.text }}</span>
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-12">
            <DropDownRequire
              :options="TextOptionsbody"
              id="SiteId"
              optionLabel="text"
              class="drop-down-val"
              optionValue="value"
              editable
              v-model="selectedOptionBody"
            ></DropDownRequire>
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-12 flex">
            <div class="p-inputgroup">
              <span class="p-inputgroup-add">
                <i class="value-icon"></i>
              </span>
              <InputText id="SiteId" v-model="valuetext" class="input-border border-icon" editable></InputText>
            </div>
            <div>
              <button @click="increaseValuetext" class="up-btn">
                <i class="pi pi-chevron-up ar-color"></i>
              </button>
              <button @click="decreaseValuetext" class="down-btn">
                <i class="pi pi-chevron-down ar-color"></i>
              </button>
            </div>
          </div>
        </div>
        <!-- Button -->
        <div class="grid">
          <div class="col-12 lg:col-12">
            <span class="general-settings-text">{{ staticData.styling.button }}</span>
          </div>
        </div>
        <!-- Button Size-->
        <div class="grid">
          <div class="col-12 lg:col-12">
            <span class="general-settings-label">{{ staticData.styling.buttonsize }}</span>
          </div>
        </div>
        <div class="grid">
          <div class="col-12">
            <div class="border-box">
              <PrimeButton
                label="Full Width"
                class="rwd-btn"
                :class="{ 'active-btn': selectedButtonSize === 'fullwidth' }"
                @click="selectedButtonSize = 'fullwidth'"
                id="fullwidth"
              ></PrimeButton>

              <PrimeButton
                label="Fit to text"
                class="rwd-btn1"
                :class="{ 'active-btn': selectedButtonSize === 'fittotext' }"
                @click="selectedButtonSize = 'fittotext'"
                id="fittotext"
              ></PrimeButton>
            </div>
          </div>
        </div>
        <!-- Text Size-->
        <div class="grid">
          <div class="col-12 lg:col-12">
            <span class="general-settings-label">{{ staticData.styling.textsize }}</span>
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-12 flex">
            <div class="p-inputgroup">
              <span class="p-inputgroup-add">
                <i class="value-icon"></i>
              </span>
              <InputText
                id="SiteId"
                v-model="valuetextsize"
                class="input-border border-icon"
                editable
              ></InputText>
            </div>
            <div>
              <button @click="increaseValuetextsize" class="up-btn">
                <i class="pi pi-chevron-up ar-color"></i>
              </button>
              <button @click="decreaseValuetextsize" class="down-btn">
                <i class="pi pi-chevron-down ar-color"></i>
              </button>
            </div>
          </div>
        </div>
        <!-- Button shape-->
        <div class="grid">
          <div class="col-12 lg:col-12">
            <span class="general-settings-label">{{ staticData.styling.shape }}</span>
          </div>
        </div>
        <div class="grid">
          <div class="col-12">
            <div class="border-box">
              <PrimeButton
                label="Square"
                class="rwd-btn"
                :class="{ 'active-btn': selectedButtonShape === 'square' }"
                @click="selectedButtonShape = 'square'"
                id="square"
              ></PrimeButton>

              <PrimeButton
                label="Rounded"
                class="rwd-btn1"
                :class="{ 'active-btn': selectedButtonShape === 'rounded' }"
                @click="selectedButtonShape = 'rounded'"
                id="rounded"
              ></PrimeButton>

              <PrimeButton
                label="Pill"
                class="rwd-btn1"
                :class="{ 'active-btn': selectedButtonShape === 'pill' }"
                @click="selectedButtonShape = 'pill'"
                id="pill"
              ></PrimeButton>

              <PrimeButton
                label="..."
                class="rwd-btn1"
                :class="{ 'active-btn': selectedButtonShape === '...' }"
                @click="selectedButtonShape = '...'"
                id="..."
              ></PrimeButton>
            </div>
          </div>
        </div>
        <!-- Button shape-->
        <div class="grid">
          <div class="col-12 lg:col-12">
            <span class="general-settings-label">{{ staticData.styling.buttoncolor }}</span>
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-12">
            <div
              id="button-color-picker-4"
              class="p-inputgroup colorpicker-component colorpicker-element"
              data-colorpicker-id="4"
              ref="colorPicker4"
            >
              <div class="border-box-color">
                <div class="col-6 statictext">{{ staticData.styling.buttontext }}</div>
                <div class="col-6 labeltext">{{ vmodel1.minwidPopupButtonBackgroundColor }}</div>
              </div>
              <span class="p-inputgroup-addon input-border" @click="toggleColorPicker(4)">
                <span
                  id="minwidPopupButtonBackgroundColorPicker"
                  class="p-colorpicker p-component p-colorpicker-overlay current-color"
                  :style="
                    'background-color: ' +
                    vmodel1.minwidPopupButtonBackgroundColor
                  "
                ></span>
              </span>
              <Sketch
                v-if="colorPickerOpen[4]"
                v-model="vmodel1.minwidPopupButtonBackgroundColor"
                @update:modelValue="
                  vmodel1.minwidPopupButtonBackgroundColor =
                    vmodel1.minwidPopupButtonBackgroundColor.hex8
                "
              />
            </div>
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-12">
            <div
              id="button-color-picker-5"
              class="p-inputgroup colorpicker-component colorpicker-element"
              data-colorpicker-id="5"
              ref="colorPicker5"
            >
              <div class="border-box-color">
                <div class="col-6 statictext">{{ staticData.styling.buttonbackground }}</div>
                <div class="col-6 labeltext">{{ vmodel1.minwidPopupButtonTextColor }}</div>
              </div>
              <span class="p-inputgroup-addon input-border" @click="toggleColorPicker(5)">
                <span
                  id="minwidPopupButtonTextColorPicker"
                  class="p-colorpicker p-component p-colorpicker-overlay current-color"
                  :style="
                    'background-color: ' + vmodel1.minwidPopupButtonTextColor
                  "
                ></span>
              </span>
              <Sketch
                v-if="colorPickerOpen[5]"
                v-model="vmodel1.minwidPopupButtonTextColor"
                @update:modelValue="
                  vmodel1.minwidPopupButtonTextColor =
                    vmodel1.minwidPopupButtonTextColor.hex8
                "
              />
            </div>
          </div>
        </div>
        <div class="grid" style="align-items: center">
          <div class="col-12 lg:col-11">
            <label
              for="friDisplayCTAButton"
              class="general-settings-textlabel"
            >{{ lmodel.friDisplayCTAButtonCenter }}</label>
          </div>
          <div class="col-12 lg:col-1">
            <div class="toggle-button toggleblock-btn">
              <ToggleButton
                v-model="vmodel1.friendIsShowCTAButtonCenter"
                onIcon="toggle-on"
                offIcon="toggle-off"
                class="toggle-btn"
              />
              <!-- <span
                  :class="{
                    'toggle-on': frdctabtn,
                    'toggle-off': !frdctabtn,
                  }"
                  @click="frdctabtn = !frdctabtn"
              ></span>-->
            </div>
          </div>
        </div>
        <div class="grid" style="align-items: center">
          <div class="col-12 lg:col-11">
            <label
              for="friDisplayCTAButton"
              class="general-settings-textlabel"
            >{{ lmodel.friHighlightCTAButton }}</label>
          </div>
          <div class="col-12 lg:col-1">
            <div class="toggle-button toggleblock-btn">
              <ToggleButton
                v-model="vmodel1.friendIsHighlightCTAButton"
                onIcon="toggle-on"
                offIcon="toggle-off"
                class="toggle-btn"
              />
              <!-- <span
                  :class="{
                    'toggle-on': frdhighctabtn,
                    'toggle-off': !frdhighctabtn,
                  }"
                  @click="frdhighctabtn = !frdhighctabtn"
              ></span>-->
            </div>
          </div>
        </div>
        <!-- Widget-->
        <div class="grid">
          <div class="col-12 lg:col-12">
            <span class="general-settings-text">{{ staticData.styling.widget }}</span>
          </div>
        </div>
        <!-- Colors-->
        <div class="grid">
          <div class="col-12 lg:col-12">
            <span class="general-settings-label">{{ staticData.styling.colors }}</span>
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-12">
            <div
              id="button-color-picker-3"
              class="p-inputgroup colorpicker-component colorpicker-element"
              data-colorpicker-id="3"
              ref="colorPicker3"
            >
              <div class="border-box-color">
                <div class="col-6 statictext">{{ staticData.styling.textcolor }}</div>
                <div class="col-6 labeltext">{{ vmodel1.popupButtonTextColor }}</div>
              </div>
              <span class="p-inputgroup-addon input-border" @click="toggleColorPicker(3)">
                <span
                  id="popupButtonTextColorPicker"
                  class="p-colorpicker p-component p-colorpicker-overlay current-color"
                  :style="'background-color: ' + vmodel1.popupButtonTextColor"
                ></span>
              </span>
              <Sketch
                v-if="colorPickerOpen[3]"
                v-model="vmodel1.popupButtonTextColor"
                @update:modelValue="
                  vmodel1.popupButtonTextColor =
                    vmodel1.popupButtonTextColor.hex8
                "
              />
            </div>
          </div>
        </div>
        <!-- Rounded Corners-->
        <div class="grid">
          <div class="col-12 lg:col-12">
            <span class="general-settings-label">{{ staticData.styling.roundedcorner }}</span>
          </div>
        </div>
        <div class="grid">
          <div class="col-11 lg:col-11 flex">
            <div class="p-inputgroup">
              <span class="p-inputgroup-add">
                <i class="radius-icon"></i>
              </span>
              <InputText id="SiteId" v-model="valuepx" class="input-border border-icon" editable></InputText>
            </div>
            <button class="hrs-btn">{{ staticData.styling.buttonpx }}</button>
            <div>
              <button @click="increaseValuepx" class="up-btn">
                <i class="pi pi-chevron-up ar-color"></i>
              </button>
              <button @click="decreaseValuepx" class="down-btn">
                <i class="pi pi-chevron-down ar-color"></i>
              </button>
            </div>
          </div>
          <div class="col-1">
            <span class="p-inputgroup-addon float" @click="toggleInputs">
              <i class="subtract-icon"></i>
            </span>
          </div>
        </div>
        <div class="grid">
          <div class="col-6 p-inputgroup" v-show="showInputs">
            <span class="p-inputgroup-add">
              <i class="radius-icon"></i>
            </span>
            <InputText id="SiteId" placeholder="0" class="input-border" editable></InputText>
          </div>
          <div class="col-5 p-inputgroup" v-show="showInputs">
            <span class="p-inputgroup-add">
              <i class="radius-right-icon"></i>
            </span>
            <InputText id="SiteId" placeholder="0" class="input-border" editable></InputText>
          </div>
          <div class="col-1" v-show="showInputs">
            <span class="p-inputgroup-addon-radius float">
              <i class="subtractclick-icon"></i>
            </span>
          </div>
          <div class="col-6 p-inputgroup" v-show="showInputs">
            <span class="p-inputgroup-add">
              <i class="radius-left-bottom-icon"></i>
            </span>
            <InputText id="SiteId" class="input-border" placeholder="0" editable></InputText>
          </div>
          <div class="col-5 p-inputgroup" v-show="showInputs">
            <span class="p-inputgroup-add">
              <i class="radius-right-bottom-icon"></i>
            </span>
            <InputText id="SiteId" placeholder="0" class="input-border" editable></InputText>
          </div>
        </div>
        <!-- Shadow Blur-->
        <div class="grid mt-1">
          <div class="col-12 lg:col-12">
            <span class="general-settings-label">{{ staticData.styling.shadowblur }}</span>
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-12 flex">
            <div class="p-inputgroup">
              <InputText id="SiteId" v-model="valueshadowblur" class="border-icon" editable></InputText>
            </div>
            <button class="hrs-btn-shadow">{{ staticData.styling.buttonpx }}</button>
          </div>
        </div>
        <!-- Shadow Spread-->
        <div class="grid">
          <div class="col-12 lg:col-12">
            <span class="general-settings-label">{{ staticData.styling.shadowspread }}</span>
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-12 flex">
            <div class="p-inputgroup">
              <InputText id="SiteId" v-model="valueshadowspread" class="border-icon" editable></InputText>
            </div>
            <button class="hrs-btn-shadow">{{ staticData.styling.buttonpx }}</button>
          </div>
        </div>
        <!-- Widget Shadow-->
        <div class="grid">
          <div class="col-12 lg:col-12">
            <span class="general-settings-label">{{ staticData.styling.widgetshadow }}</span>
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-12">
            <div
              id="button-color-picker-6"
              class="p-inputgroup colorpicker-component colorpicker-element"
              data-colorpicker-id="6"
              ref="colorPicker6"
            >
              <div class="border-box-color">
                <div class="col-6 statictext">{{ staticData.styling.shadowcolor }}</div>
                <div class="col-6 labeltext">{{ vmodel1.widgetShadowColor }}</div>
              </div>
              <span class="p-inputgroup-addon input-border" @click="toggleColorPicker(6)">
                <span
                  id="widgetShadowColorPicker"
                  class="p-colorpicker p-component p-colorpicker-overlay current-color"
                  :style="'background-color: ' + vmodel1.widgetShadowColor"
                ></span>
              </span>
              <Sketch
                v-if="colorPickerOpen[6]"
                v-model="vmodel1.widgetShadowColor"
                @update:modelValue="
                  vmodel1.widgetShadowColor = vmodel1.widgetShadowColor.hex8
                "
              />
            </div>
          </div>
        </div>
      </TabPanel>

      <TabPanel header="Behaviour">
        <div class="grid col-12">
          <span class="general-settings-text">{{ staticData.behaviour.on_click }}</span>
        </div>
        <div class="grid">
          <div class="col-12">
            <DropDownRequire
              :options="Options"
              id="SiteId"
              placeholder="Go to maximized view"
              optionLabel="text"
              class="drop-down-val"
              optionValue="value"
              v-model="optionsSelect"
              editable
              :disabled="true"
            ></DropDownRequire>
          </div>
        </div>
        <div class="grid col-12 mt-1">
          <span class="general-settings-text">
            {{
            staticData.behaviour.submit_btn
            }}
          </span>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-12">
            <RadioButton v-model="selectSubmitfrnd" type="radio" :value="0" class="radio-class" />
            <label class="ml-2 checkbox-font">
              <span>{{ staticData.behaviour.always_active }}</span>
            </label>
          </div>
          <div class="col-12 lg:col-12 py-0">
            <RadioButton v-model="selectSubmitfrnd" type="radio" :value="1" class="radio-class" />
            <label class="ml-2 checkbox-font">
              <span>{{ staticData.behaviour.active_fieldVal }}</span>
            </label>
          </div>
        </div>
      </TabPanel>
    </TabView>
    <div class="border-line mt-2"></div>
  </div>
</template>

<script>
import TabView from "primevue/tabview";
import staticData from "@/staticdata/static.json";
import { Sketch } from "@ckpack/vue-color";
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
// import DataLayerService from "@/services/data-layer.service.js";
export default {
  components: {
    TabView,
    Sketch,
    Cropper
  },

  data() {
    return {
      frdcustomErrorMessage: [],
      cropperIsActiveMaxWidDesk: false,
      cropperIsActiveMaxWidMob: false,
      counter: 1,
      friEnableSelectOption: [],
      // voyadoDynamicConsentsOptions: [],
      frdSelectOptErrorMessage: [],
      frdErrorMessage: [],
      id: this.$route.params.id,
      isOpenDropdown: false,
      opnNextDealByTag: "",
      redirectToUrl: "",
      friConsentsReq: false,
      friConsentsDefSelected: false,
      staticData: staticData.maximized,
      showInputs: false,
      imguploaded: false,
      embedMaxWid: false,
      selectedWidgetType: "text",
      selectedImgType: "imgarchive",
      displayimgwidget: true,
      imgurlval: "http://localhost:8080/img/abc.jpg",
      imageUp: "",
      imgurl: false,
      imgarchive: false,
      colorPickerOpen: {
        1: false,
        2: false,
        3: false,
        4: false,
        5: false,
        6: false,
        7: false
      },
      isDisabled: true,
      optionsSelect: "next_step",
      selectSubmitfrnd: 0,
      Options: [
        { text: "Go to next step", value: "next_step" },
        { text: "Go to previous step", value: "prev_step" }
      ],
      positionSelect: "bottom_right",
      PositionOptions: [
        { text: "Bottom right", value: "bottom_right" },
        { text: "Bottom left", value: "bottom_left" },
        { text: "Top right", value: "top_right" },
        { text: "Top left", value: "top_left" }
      ],
      imgBorder: false,
      // choicesBtn: this.vmodel.friEnableSingleSelectOptions,
      selectedButtonSize: "fullwidth",
      selectedButtonShape: "square",
      valuepx: 0,
      valueshadowblur: 0,
      valueshadowspread: 0,
      value: "0px",
      valuetext: "0px",
      valuetextsize: "0px",
      selectedOptionText: "SRN",
      selectedOptionBody: "SR",
      TextOptions: [
        { text: "Sora normal", value: "SRN" },
        { text: "Voyado", value: "VY" }
      ],
      TextOptionsbody: [
        { text: "Sora", value: "SR" },
        { text: "Voyado", value: "VY" }
      ],
      voffset: 1,
      cntbtnValue: "1. Continue (Fri)",
      reqAns: false,
      dropDownBtn: false,
      multipleAns: false,
      uploadedSuccessfully: "Image uploaded successfully"
    };
  },

  props: {
    dealId: {
      type: String,
      default: null
    },
    tabId: {
      type: Number,
      default: 0
    },
    lmodel: {
      type: Object,
      default: null
    },
    dmodel: {
      type: Object,
      default: null
    },
    vmodel: {
      type: Object,
      default: null
    },
    valmodel: {
      type: Object,
      default: null
    },
    dealStatus: {
      type: Number,
      default: null
    },
    isRedealText: {
      type: Boolean,
      default: false
    },
    customerCampaignDealyDaysError: {
      type: String,
      default: null
    },
    enableAmbassadorMailsAmb: {
      type: Boolean,
      default: false
    },
    modelstate: {
      type: Object,
      default: null
    },
    selectedDeviceType: {
      type: String,
      required: true
    },
    voyadoDomain: {
      type: String,
      default: ""
    },
    voyadoApi: {
      type: String,
      default: ""
    },
    submitter: {
      type: String,
      default: ""
    },
    voyadoDynamicConsentsOptions: {
      type: Array
    }
  },
  watch: {
    "vmodel1.enableAmbConsents"(newValue) {
      if (!newValue) {
        this.isOpenDropdown = false;
        this.vmodel1.frdConsents = [];
      }
    },
    "vmodel1.friEnableSelectOption": {
      deep: true,
      async handler(newVal) {
        await this.validateCustomTag();
        newVal.forEach(tagObj => {
          if (
            tagObj.label !== null &&
            tagObj.label !== "" &&
            tagObj.label !== undefined &&
            tagObj.tag !== null &&
            tagObj.tag !== "" &&
            tagObj.tag !== undefined &&
            !tagObj.label.trim() &&
            !tagObj.tag.trim()
          ) {
            tagObj.opnNextDealByTag = "";
            tagObj.redirectToUrl = "";
          }
          return tagObj;
        });
      }
    },
    submitter: {
      deep: true,
      async handler(newVal) {
        if (newVal !== "") {
          await this.validateCustomTag();
        }
      }
    }
  },
  computed: {
    vmodel1: {
      get() {
        return this.vmodel;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      }
    }
  },

  mounted() {
    // if(this.vmodel1.friEnableSelectOption[0].customtagstype == 1){
    //   this.dropDownBtn = true
    // }

    this.validateCustomTag();

    document.body.style.overflow = "hidden";
    // if (this.vmodel1.setLanguage && this.voyadoApi && this.voyadoDomain) {
    //   this.GetDynamicConsents();
    // }

    if (this.$route.params.id) {
      this.isOpenDropdown = true;
    }

    if (this.vmodel1.friendIsHighlightCTAButton == true) {
      this.selectSubmitfrnd = 0;
    } else {
      this.selectSubmitfrnd = 1;
    }

    document.addEventListener("click", this.handleOutsideClick);
  },

  beforeUnmount() {
    document.removeEventListener("click", this.handleOutsideClick);
  },

  methods: {
    // GetDynamicConsents() {
    //   const apiUrl = `/site/getdynamicconsents?apikey=${this.voyadoApi}&domain=${this.voyadoDomain}&language=${this.vmodel1.setLanguage}`;
    //   DataLayerService.get(apiUrl).then(result => {
    //     if (result !== null && result !== undefined && result != []) {
    //       this.voyadoDynamicConsentsOptions = result;
    //     }
    //   });
    // },

    removeSingleComponentSelectFrd(index) {
      if (this.vmodel1.friCustomtags.length > 1) {
        this.vmodel1.friCustomtags.splice(index);
      }
    },

    addComponentSingleSelectFrd() {
      this.vmodel1.friCustomtags.push({
        label: "",
        tag: "",
        opnNextDealByTag: "",
        redirectToUrl: ""
      });
    },

    showEmailval() {
      if (!this.vmodel1.friShowEmail) {
        this.vmodel1.friEmailText = "";
      }
      if (
        this.vmodel1.friShowPhoneNumber == false &&
        this.vmodel1.friShowPersonalNumber == false &&
        this.vmodel1.friShowEmail == false
      ) {
        this.vmodel1.friendHideOptinFriend = true;
      }

      if (this.vmodel1.friendHideOptinFriend) {
        this.vmodel1.friShowPhoneNumber = false;
        this.vmodel1.friShowPersonalNumber = false;
        this.vmodel1.friShowEmail = false;
      }
    },

    removeConsentsDropdown(index) {
      this.vmodel1.friConsents.splice(index, 1);
    },

    validateCustomTag() {
      this.frdErrorMessage = [];
      this.frdSelectOptErrorMessage = [];
      this.frdcustomErrorMessage = [];

      for (let i = 0; i < this.vmodel1?.friCustomtags.length; i++) {
        let obj = {
          label: false,
          tag: false
        };
        this.frdcustomErrorMessage.push(obj);
      }

      if (
        this.vmodel1?.friCustomtags &&
        this.vmodel1?.friCustomtags.length > 0
      ) {
        if (
          this.submitter !== "" &&
          this.submitter !== null &&
          this.submitter !== undefined
        ) {
          this.vmodel1?.friCustomtags.map(async (x, index) => {
            if (
              this.vmodel1.friCustomFieldName !== "" &&
              this.vmodel1.friCustomFieldName !== null &&
              this.vmodel1.friCustomFieldName !== undefined
            ) {
              this.frdcustomErrorMessage[index].label = true;
              this.frdcustomErrorMessage[index].tag = true;
              if (x.label !== "" && x.label !== null && x.label !== undefined) {
                this.frdcustomErrorMessage[index].label = false;
              }
              if (x.tag !== "" && x.tag !== null && x.tag !== undefined) {
                this.frdcustomErrorMessage[index].tag = false;
              }
            } else {
              this.frdcustomErrorMessage[index].label = false;
              this.frdcustomErrorMessage[index].tag = false;
            }
          });
        }
      }

      if (
        this.submitter !== "" &&
        this.submitter !== null &&
        this.submitter !== undefined
      ) {
        if (
          this.vmodel1.friEnableSelectOption &&
          this.vmodel1.friEnableSelectOption.length > 0
        ) {
          this.vmodel1.friEnableSelectOption.map((x, index) => {
            if (
              x.customfieldname !== "" &&
              x.customfieldname !== null &&
              x.customfieldname !== undefined
            ) {
              this.frdErrorMessage[index] = false;
            } else {
              this.frdErrorMessage[index] = true;
            }
          });

          for (let i = 0; i < this.vmodel1.friEnableSelectOption.length; i++) {
            if (!this.frdSelectOptErrorMessage[i]) {
              this.frdSelectOptErrorMessage[i] = [];
            }

            for (
              let j = 0;
              j < this.vmodel1.friEnableSelectOption[i].customtags.length;
              j++
            ) {
              let obj = {
                label: false,
                tag: false
              };
              this.frdSelectOptErrorMessage[i].push(obj);
            }
          }

          this.vmodel1.friEnableSelectOption.map((x, index) => {
            x.customtags.map((item, subindex) => {
              if (
                x.customfieldname !== "" &&
                x.customfieldname !== null &&
                x.customfieldname !== undefined
              ) {
                this.frdSelectOptErrorMessage[index][subindex].label = true;
                this.frdSelectOptErrorMessage[index][subindex].tag = true;
                if (
                  item.label !== "" &&
                  item.label !== null &&
                  item.label !== undefined
                ) {
                  this.frdSelectOptErrorMessage[index][subindex].label = false;
                }
                if (
                  item.tag !== "" &&
                  item.tag !== null &&
                  item.tag !== undefined
                ) {
                  this.frdSelectOptErrorMessage[index][subindex].tag = false;
                }
              } else {
                this.frdErrorMessage[index] = true;
                this.frdSelectOptErrorMessage[index][subindex].label = false;
                this.frdSelectOptErrorMessage[index][subindex].tag = false;
              }
            });
          });
        }
      }

      let frdErrorArray = this.frdErrorMessage.includes(true);
      let frdSelectOptErrorMessageArray = this.frdSelectOptErrorMessage.some(
        row => row.some(obj => obj.label === true || obj.tag === true)
      );

      let frdCustomErrorMessageArray = this.frdcustomErrorMessage.some(
        obj => obj.label === true || obj.tag === true
      );

      if (
        frdErrorArray ||
        frdSelectOptErrorMessageArray ||
        frdCustomErrorMessageArray
      ) {
        this.$emit("displayError", true);
      } else {
        this.$emit("displayError", false);
      }
    },

    getFilteredOptions(index) {
      const selectedValues = this.vmodel1.friConsents
        .map((friConsents, i) => (i === index ? null : friConsents.id))
        .filter(value => value !== null);

      return this.voyadoDynamicConsentsOptions.filter(
        option => !selectedValues.includes(option.value)
      );
    },

    updateSelected(friConsents) {
      const selectedOption = this.voyadoDynamicConsentsOptions.find(
        option => option.value === friConsents.id
      );
      if (selectedOption) {
        friConsents.id = selectedOption.value;
        friConsents.name = selectedOption.name;
        friConsents.displayText = selectedOption.displayText;
        friConsents.linkText = selectedOption.linkText;
        friConsents.conditionText = selectedOption.conditionText;
      }
    },

    //Desktop Max image
    openFileUploadDesktop() {
      this.$refs.filedesktop.choose();
    },
    captureCroppedImageMaxWidDesk() {
      const { canvas } = this.$refs.cropperComponent6.getResult();
      this.vmodel1.friHeaderimagepath = canvas.toDataURL();
      this.vmodel1.friHeaderimagestream = canvas.toDataURL();
      this.croppedImage = this.vmodel1.friHeaderimagepath;
      this.cropperIsActiveMaxWidDesk = false;
    },
    closeCropperMaxWidDesk() {
      this.cropperIsActiveMaxWidDesk = false;
    },
    cropImageMaxDesktop() {
      this.cropperIsActiveMaxWidDesk = true;
    },
    clearImageDesktop() {
      this.$refs.filedesktop.clear();
      this.vmodel1.friHeaderimagestream = null;
      this.vmodel1.friHeaderimagename = null;
      this.vmodel1.friHeaderimagepath = null;
      this.vmodel1.friDesktimgwdth = 0;
      this.vmodel1.friDesktimghght = 0;
    },
    replaceFileDesktop() {
      this.$refs.filedesktop.clear();
      this.$refs.filedesktop.choose();
    },
    handleFileUploadDesktop(fileObj) {
      var file = this.$refs.filedesktop.files[0];
      if (
        !fileObj ||
        (fileObj && !fileObj.files) ||
        (fileObj && fileObj.files && fileObj.files.length === 0)
      ) {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: this.unsupportedFileTypeMsg,
          life: 3000
        });
        this.$refs.file.clear();
      } else {
        let reader = new FileReader();
        reader.onload = () => {
          var image = new Image();
          image.onload = () => {
            this.vmodel1.friHeaderimagestream = reader.result;
            this.vmodel1.friHeaderimagename = file.name;
            this.vmodel1.friHeaderimagepath = reader.result;
            // this.vmodel1.ambassador.desktimghght = image.height;
            // this.vmodel1.ambassador.desktimgwdth = image.width;
            // if (this.vmodel1.ambassador.desktimgwdth > this.computedwidth) {
            //   this.newwidth = 300;
            // } else {
            //   this.newwidth = this.vmodel1.ambassador.desktimgwdth;
            // }
            // if (this.vmodel1.ambassador.desktimghght > this.computedheight) {
            //   this.newheight = 300;
            // } else {
            //   this.newheight = this.vmodel1.ambassador.desktimghght;
            // }
            this.$toast.add({
              severity: "success",
              summary: "Success",
              detail: this.uploadedSuccessfully,
              life: 3000
            });
          };
          image.src = reader.result;
        };
        reader.readAsDataURL(file);
      }
    },

    //Mobile Max image

    handleFileUpload(fileObj) {
      var file = this.$refs.filemobile.files[0];
      if (
        !fileObj ||
        (fileObj && !fileObj.files) ||
        (fileObj && fileObj.files && fileObj.files.length === 0)
      ) {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: this.unsupportedFileTypeMsg,
          life: 3000
        });
        this.$refs.file.clear();
      } else {
        let reader = new FileReader();
        reader.onload = () => {
          var image = new Image();
          image.onload = () => {
            this.vmodel1.friMobHeaderimagestream = reader.result;
            this.vmodel1.friMobHeaderimagename = file.name;
            this.vmodel1.friMobHeaderimagepath = reader.result;
            // this.vmodel1.ambassador.mobimghght = image.height;
            // this.vmodel1.ambassador.mobimgwdth = image.width;
            // if (this.vmodel1.ambassador.mobimgwdth > this.computedwidthmob) {
            //   this.newwidthmob = 300;
            // } else {
            //   this.newwidthmob = this.vmodel1.ambassador.mobimgwdth;
            // }
            // if (this.vmodel1.ambassador.mobimghght > this.computedheightmob) {
            //   this.newheightmob = 300;
            // } else {
            //   this.newheightmob = this.vmodel1.ambassador.mobimghght;
            // }
            this.$toast.add({
              severity: "success",
              summary: "Success",
              detail: this.uploadedSuccessfully,
              life: 3000
            });
          };
          image.src = reader.result;
        };
        reader.readAsDataURL(file);
      }
    },
    openFileUploadMobile() {
      this.$refs.filemobile.choose();
    },
    removeComponent(index) {
      this.vmodel1.friCustomtags.splice(index, 1);
    },
    replaceFileMobile() {
      this.$refs.filemobile.clear();
      this.$refs.filemobile.choose();
    },
    clearImageMobile() {
      this.$refs.filemobile.clear();
      this.vmodel1.friMobHeaderimagestream = null;
      this.vmodel1.friMobHeaderimagename = null;
      this.vmodel1.friMobHeaderimagepath = null;
    },
    cropImageMaxMobile() {
      this.cropperIsActiveMaxWidMob = true;
    },
    closeCropperMaxWidMob() {
      this.cropperIsActiveMaxWidMob = false;
    },
    captureCroppedImageMaxWidMob() {
      const { canvas } = this.$refs.cropperComponent5.getResult();
      this.vmodel1.friMobHeaderimagename = canvas.toDataURL();
      this.vmodel1.friMobHeaderimagestream = canvas.toDataURL();
      this.croppedImage = this.vmodel1.friMobHeaderimagename;

      this.cropperIsActiveMaxWidMob = false;
    },
    updateCustomTag(subindex) {
      if (
        this.vmodel1.friEnableSelectOption &&
        this.vmodel1.friEnableSelectOption.length > 0
      ) {
        this.vmodel1.friEnableSelectOption[
          subindex
        ].customtags = this.vmodel1.friEnableSelectOption[
          subindex
        ].customtags.map(x => {
          if (x.label == "" && x.tag == "") {
            x.opnNextDealByTag = "";
            x.redirectToUrl = "";
          }
          return x;
        });
      }
    },
    getOptionText(value) {
      const option = this.voyadoDynamicConsentsOptions.find(
        opt => opt.value === value
      );
      return option ? `${option.name}` : "";
    },

    addConsentsDropdown() {
      this.isOpenDropdown = true;
      this.vmodel1.friConsents.push({
        id: null,
        name: null,
        req: false,
        defaultSelected: false,
        conditionText: "",
        displayText: "",
        linkText: ""
      });
    },

    // toggleHideoptfrd() {
    //   this.hideOptInFrd = !this.hideOptInFrd;
    //   if (this.hideOptInFrd) {
    //     this.phoneNumber = false;
    //     this.personNumber = false;
    //     this.fullName = false;
    //     this.emailButton = false;
    //     this.frdfNameLName = false;
    //   } else {
    //     this.emailButton = true;
    //     this.fullName = true;
    //   }
    // },

    // updateCustomTag(subindex) {
    //   if (
    //     this.vmodel1.friEnableSelectOption &&
    //     this.vmodel1.friEnableSelectOption.length > 0
    //   ) {
    //     this.vmodel1.friEnableSelectOption[subindex].customtags =
    //       this.vmodel1.friEnableSelectOption[subindex].customtags.map((x) => {
    //         if (x.label == "" && x.tag == "") {
    //           x.opnNextDealByTag = "";
    //           x.redirectToUrl = "";
    //         }
    //         return x;
    //       });
    //   }
    // },

    addComponent() {
      this.vmodel1.friCustomtags.push({
        label: "",
        tag: "",
        opnNextDealByTag: "",
        redirectToUrl: ""
      });
      this.counter++;
      // const scrollHeight =
      //   document.getElementById("option-list").scrollHeight + 35;
      // setTimeout(() => {
      //   document
      //     .getElementById("option-list")
      //     .scrollTo({ left: 0, top: scrollHeight, behavior: "smooth" });
      // }, 100);
    },

    removeaddSingleSelectOption(subindex) {
      if (this.vmodel1.friEnableSelectOption.length > 1) {
        this.vmodel1.friEnableSelectOption.splice(subindex, 1);
      }
    },

    addSingleSelectOption() {
      this.vmodel1.friEnableSelectOption.push({
        customtagstitle: "",
        customfieldname: "",
        customtagstype: 0,
        cfldmdtry: false,
        customtags: [
          {
            label: "",
            tag: "",
            opnNextDealByTag: "",
            redirectToUrl: ""
          },
          {
            label: "",
            tag: "",
            opnNextDealByTag: "",
            redirectToUrl: ""
          }
        ]
      });
    },

    removeComponentSelect(subindex, index) {
      if (this.vmodel1.friEnableSelectOption[subindex].customtags.length > 1) {
        this.vmodel1.friEnableSelectOption[subindex].customtags.splice(
          index,
          1
        );
      }
    },

    addComponentSelect(subindex) {
      this.vmodel1.friEnableSelectOption[subindex].customtags.push({
        label: "",
        tag: "",
        opnNextDealByTag: "",
        redirectToUrl: ""
      });
      // const scrollHeight =
      //   document.getElementById("option-list").scrollHeight + 35;
      // setTimeout(() => {
      //   document
      //     .getElementById("option-list")
      //     .scrollTo({ left: 0, top: scrollHeight, behavior: "smooth" });
      // }, 100);
    },

    increaseValue() {
      const numericValue = parseInt(this.value);
      if (numericValue < 100) {
        this.value = numericValue + 1 + "px";
      }
    },
    decreaseValue() {
      const numericValue = parseInt(this.value);
      if (numericValue > 0) {
        this.value = numericValue - 1 + "px";
      }
    },
    increaseValuetext() {
      const numericValue = parseInt(this.valuetext);
      if (numericValue < 100) {
        this.valuetext = numericValue + 1 + "px";
      }
    },
    decreaseValuetext() {
      const numericValue = parseInt(this.valuetext);
      if (numericValue > 0) {
        this.valuetext = numericValue - 1 + "px";
      }
    },
    increaseValuetextsize() {
      const numericValue = parseInt(this.valuetextsize);
      if (numericValue < 100) {
        this.valuetextsize = numericValue + 1 + "px";
      }
    },
    decreaseValuetextsize() {
      const numericValue = parseInt(this.valuetextsize);
      if (numericValue > 0) {
        this.valuetextsize = numericValue - 1 + "px";
      }
    },
    increaseValuepx() {
      if (this.valuepx < 100) {
        this.valuepx++;
      }
    },
    decreaseValuepx() {
      if (this.valuepx > 0) {
        this.valuepx--;
      }
    },
    toggleInputs() {
      this.showInputs = !this.showInputs;
    },
    toggleColorPicker(id) {
      this.colorPickerOpen[id] = !this.colorPickerOpen[id];
      for (let key in this.colorPickerOpen) {
        if (key != id) {
          this.colorPickerOpen[key] = false;
        }
      }
    },
    selectWidgetType(value) {
      this.selectedWidgetType = value;
      if (value === "text") {
        this.isText = true;
        this.isImg = false;
      } else if (value === "image") {
        this.isImg = true;
        this.isText = false;
      }
    },
    selectImgType(value) {
      this.selectedImgType = value;
      if (value === "imgurl") {
        this.imgurl = true;
        this.imgarchive = false;
      } else if (value === "imgarchive") {
        this.imgurl = false;
        this.imgarchive = true;
      }
    },

    clearImage() {
      this.imageUp = "";
      this.imguploaded = false;
      this.$refs.photo.clear();
    },

    openFileUpload() {
      this.$refs.photo.choose();
    },
    onAdvancedUpload(fileObj) {
      var file = this.$refs.photo.files[0];
      if (
        !fileObj ||
        (fileObj && !fileObj.files) ||
        (fileObj && fileObj.files && fileObj.files.length === 0)
      ) {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: this.unsupportedFileTypeMsg,
          life: 3000
        });
        this.$refs.file.clear();
      } else {
        let reader = new FileReader();
        reader.onload = () => {
          var image = new Image();
          image.onload = () => {
            this.imageUp = reader.result;
            this.$toast.add({
              severity: "success",
              summary: "Success",
              detail: this.uploadedSuccessfully,
              life: 3000
            });
          };
          image.src = reader.result;
          if (image.src) {
            this.imguploaded = true;
          }
        };
        reader.readAsDataURL(file);
      }
    },

    handleOutsideClick(event) {
      for (let key in this.$refs) {
        if (key.startsWith("colorPicker")) {
          if (!this.$refs[key].contains(event.target)) {
            const id = parseInt(key.replace("colorPicker", ""), 10);
            this.colorPickerOpen[id] = false;
          }
        }
      }
    },

    addHashPrefix() {
      if (
        this.vmodel1.minwidPopupButtonBackgroundColor &&
        !this.vmodel1.minwidPopupButtonBackgroundColor.startsWith("#")
      ) {
        this.vmodel1.minwidPopupButtonBackgroundColor =
          "#" + this.vmodel1.minwidPopupButtonBackgroundColor.toUpperCase();
      } else if (
        this.vmodel1.minwidPopupButtonTextColor &&
        !this.vmodel1.minwidPopupButtonTextColor.startsWith("#")
      ) {
        this.vmodel1.minwidPopupButtonTextColor =
          "#" + this.vmodel1.minwidPopupButtonTextColor.toUpperCase();
      } else if (
        this.vmodel1.widgetShadowColor &&
        !this.vmodel1.widgetShadowColor.startsWith("#")
      ) {
        this.vmodel1.widgetShadowColor =
          "#" + this.vmodel1.widgetShadowColor.toUpperCase();
      } else if (
        this.vmodel1.popupButtonBackgroundColor &&
        !this.vmodel1.popupButtonBackgroundColor.startsWith("#")
      ) {
        this.vmodel1.popupButtonBackgroundColor =
          "#" + this.vmodel1.popupButtonBackgroundColor.toUpperCase();
      } else if (
        this.vmodel1.popupButtonTextColor &&
        !this.vmodel1.popupButtonTextColor.startsWith("#")
      ) {
        this.vmodel1.popupButtonTextColor =
          "#" + this.vmodel1.popupButtonTextColor.toUpperCase();
      } else if (
        this.vmodel1.widgetBackgroundColor &&
        !this.vmodel1.widgetBackgroundColor.startsWith("#")
      ) {
        this.vmodel1.widgetBackgroundColor =
          "#" + this.vmodel1.widgetBackgroundColor.toUpperCase();
      } else if (
        this.vmodel1.setTextColor &&
        !this.vmodel1.setTextColor.startsWith("#")
      ) {
        this.vmodel1.setTextColor =
          "#" + this.vmodel1.setTextColor.toUpperCase();
      } else {
        this.vmodel1.minwidPopupButtonBackgroundColor = this.vmodel1.minwidPopupButtonBackgroundColor.toUpperCase();
        this.vmodel1.minwidPopupButtonTextColor = this.vmodel1.minwidPopupButtonTextColor.toUpperCase();
        this.vmodel1.widgetShadowColor = this.vmodel1.widgetShadowColor.toUpperCase();
        this.vmodel1.popupButtonBackgroundColor = this.vmodel1.popupButtonBackgroundColor.toUpperCase();
        this.vmodel1.popupButtonTextColor = this.vmodel1.popupButtonTextColor.toUpperCase();
        this.vmodel1.widgetBackgroundColor = this.vmodel1.widgetBackgroundColor.toUpperCase();
        this.vmodel1.setTextColor = this.vmodel1.setTextColor.toUpperCase();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.border-line {
  border-top: 1px solid #e5e5e5;
}

:deep(.p-tabview .p-tabview-nav li .p-tabview-nav-link:not(.p-disabled):focus) {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none !important;
}
:deep(.p-tabview .p-tabview-nav li .p-tabview-nav-link) {
  border: none !important;
  background: #ffffff;
  color: #000000;
  padding: 1rem 1.125rem 0rem;
  font-weight: 400;
  font-size: 14.22px;
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s,
    box-shadow 0.2s, outline-color 0.2s;
  margin: 0 0 -1px 0;
  outline-color: transparent;
}
:deep(.p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link) {
  background: #ffffff;
  // border-color: #dee2e6 !important;
  border: 1px solid #dee2e6 !important;
  border-width: 0px 0px 1px 0px !important;
  color: #000000;
  font-weight: 400;
  font-size: 14.22px;
  line-height: 17.1px;
}
:deep(.p-tabview .p-tabview-nav li .p-tabview-nav-link span) {
  padding-bottom: 1rem;
  border: none;
}
:deep(.p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link span) {
  padding-bottom: 1rem;
  border-bottom: 3px solid #791a3f;
}
:deep(.p-tabview .p-tabview-ink-bar) {
  display: none !important;
}

:deep(.p-tabview .p-tabview-panels) {
  padding: 16px !important;
  background: #ffffff;
  border: 0 none;
  color: #212529;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
}

.setting-layout {
  margin-top: 180px;
  font-family: "Voyado Text";
}
:deep(.setting-layout.p-tabview .p-tabview-panels) {
  overflow-y: auto;
  overflow-x: hidden;
  max-height: calc(100vh - 260px);
}

:deep(.p-tabview .p-tabview-panels) {
  padding: 16px !important;
}

.general-settings-text {
  font-size: 14.22px !important;
  font-weight: 500 !important;
  line-height: 17.1px !important;
  color: #21211f !important;
}

.general-settings-textlabel {
  font-size: 14.22px !important;
  font-weight: 400 !important;
  line-height: 17.1px !important;
  color: #21211f !important;
  height: 18px !important;
}

.p-inputgroup > .p-inputwrapper:last-child > .p-inputtext {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
.p-inputgroup > input:first-child {
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px;
  border-right: none;
}

.p-inputgroup-add {
  background: #fff !important;
  color: #495057;
  border-bottom: 1px solid #c0c0bc;
  border-top: 1px solid #c0c0bc;
  border-left: 1px solid #c0c0bc;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 0.75rem;
  height: 40px;
  border-top-left-radius: 4px !important;
  border-bottom-left-radius: 4px !important;
}

.p-inputgroup-addon {
  background: #fff !important;
  color: #495057;
  border-top: 1px solid #c0c0bc;
  // border-left: none;
  border-bottom: 1px solid #c0c0bc;
  padding: 0.5rem 0.75rem;
  /* min-width: 2.357rem; */
  // width: 100%;
  height: 40px;
  // border-top-left-radius: 0px !important;
  // border-bottom-left-radius: 0px !important;
  border-right: 1px solid #c0c0bc;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.p-inputgroup-addon-radius {
  background: #9b1c45;
  color: #495057;
  border-top: 1px solid #c0c0bc;
  border-bottom: 1px solid #c0c0bc;
  padding: 0.5rem 0.75rem;
  height: 40px;
  border-right: 1px solid #c0c0bc;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.input-border {
  border-top-left-radius: 0px !important;
  border-left: none !important;
  border-bottom-left-radius: 0px !important;
}

.border-icon {
  border-right: none;
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}

.float {
  float: right;
}

:deep(.p-inputtext) {
  color: #21211f !important;
  font-size: 16px;
  width: 100%;
  height: 40px;
  box-shadow: none;
  // border: 1px solid #c0c0bc;
  border-radius: 0.25rem;
  font-weight: 400;
  line-height: 1;
  padding: 0.375rem 0.75rem;
  font-family: "Voyado Text";
}
:deep(.p-inputtext:enabled:focus) {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none;
  // border: 1px solid #cedacf;
}
.p-inputtext:enabled:focus {
  outline: 0 none !important;
  outline-offset: 0 !important;
  box-shadow: none !important;
  border: #c0c0bc !important;
  outline: 2px solid #222222 !important;
  border-style: double !important;
}
.hrs-btn {
  border: none;
  height: 40px !important;
  background-color: #fff;
  border-top: 1px solid #c0c0bc;
  border-bottom: 1px solid #c0c0bc;
  color: #797971;
  cursor: text;
}
.down-btn {
  border: 1px solid #c0c0bc;
  background-color: #fff;
  height: 20px;
  width: 30px;
  display: grid;
  border-bottom-right-radius: 4px;
}

.up-btn {
  border: 1px solid #c0c0bc;
  background-color: #fff;
  height: 20px;
  width: 30px;
  display: grid;
  border-top-right-radius: 4px;
}

.ar-color {
  color: #797971 !important;
}

.colorpicker-component {
  position: relative;
}

.current-color {
  display: inline-block;
  width: 28px;
  height: 28px;
  background-color: #000;
  cursor: pointer;
  border: 1px solid #c0c0bc;
  border-radius: 8px;
}
/* Style for the input field */
.colorpicker-input {
  width: 376px !important;
  height: 40px !important;
  padding: 6px 12px;
  border-bottom-right-radius: 0px;
  border-top-right-radius: 0px;
  position: relative;
}
.p-inputtextcolor {
  color: #21211f !important;
  font-size: 16px;
  width: 100%;
  box-shadow: none;
  // border: 1px solid #C0C0BC;
  border-radius: 0.25rem;
  font-weight: 400;
  line-height: 1;
  padding: 0.375rem 0.75rem;
  font-family: "Voyado Text";
}

.p-colorpicker-preview {
  width: 25px !important;
  height: 25px;
}

.vc-sketch {
  position: absolute !important;
  z-index: 1 !important;
  right: 0 !important;
  top: 40px !important;
  width: 200px;
  padding: 10px 10px 0;
  box-sizing: initial;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.15), 0 8px 16px rgba(0, 0, 0, 0.15);
}

.p-inputtextcolor::before {
  content: "Shadow color ";
  position: absolute;
  left: 5px;
  top: 50%;
  transform: translateY(-50%);
  color: black;
}

.p-inputtextcolor::after {
  content: attr(value);
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translateY(-50%);
  color: black;
}

.p-inputgroup > .p-inputwrapper:last-child > .p-inputtextcolor {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}

.border-box-color {
  border: 1px solid #c0c0bc;
  height: 40px;
  display: flex;
  width: 100%;
  text-align: center;
  border-right: none !important;
  border-top-left-radius: 4px !important;
  border-bottom-left-radius: 4px !important;
}

// maximized css

.toggle-button {
  display: flex;
  align-items: center;
}
.toggle-button span {
  cursor: pointer;
  vertical-align: middle;
}

:deep(.p-button .p-button-icon-left) {
  margin-right: 0rem;
}

.border-box {
  border: 1px solid #c0c0bc;
  height: 40px;
  display: flex;
  border-radius: 4px;
  width: 100%;
  text-align: center;
  // margin-top: inherit !important;
  //   justify-content: center;
}

.upload-text {
  width: 100%;
  height: 24px;
  // font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #000000;
  flex: none;
  order: 0;
  flex-grow: 0;
}

.checkbox-font {
  margin-left: 4px !important;
  font-family: "Voyado Text" !important;
  font-size: 14.22px !important;
  font-weight: 400 !important;
  line-height: 17.1px !important;
  text-align: left !important;
}
.radio-class {
  height: 20 px;
  padding: 4px 0px 0px 0px;
  border-radius: 10px 0px 0px 0px;
  border: 1px 0px 0px 0px;
  background: #ffffff;
}

.deal-img {
  padding: 12px 0px 0px 0px;
}
.general-settings-label {
  font-size: 14.22px !important;
  font-weight: 400 !important;
  line-height: 17.1px !important;
  color: #666666;
  font-family: "Voyado Text";
  // text-align: left;
}

.hrs-btn-shadow {
  border: none;
  height: 40px !important;
  background-color: #fff;
  border-top: 1px solid #c0c0bc;
  border-bottom: 1px solid #c0c0bc;
  border-right: 1px solid #c0c0bc;
  color: #797971;
  cursor: text;
  border-bottom-right-radius: 4px;
  border-top-right-radius: 4px;
}

.statictext {
  justify-content: left;
  display: flex;
  color: #21211f;
  font-family: "Voyado Text";
  font-size: 14px;
}
.labeltext {
  justify-content: right;
  display: flex;
  color: #21211f;
  font-family: "Voyado Text";
  font-size: 14px;
}

.flex {
  display: flex;
}

:deep(.p-button:focus) {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none !important;
}
.text-value {
  font-family: "Voyado Text";
  font-size: 14.22px;
  font-weight: 500;
  line-height: 17.1px;
  text-align: left;
  color: #21211f;
}
.general-text {
  font-family: "Voyado Text";
  font-size: 14.22px;
  font-weight: 500;
  line-height: 17.1px;
  text-align: left;
  color: #21211f;
}
.general-settings-labeltoggale {
  font-size: 14.22px !important;
  font-weight: 400 !important;
  line-height: 17.1px !important;
  color: #21211f;
  font-family: "Voyado Text";
  // text-align: left;
}

.btn-add-select {
  background-color: #2d6e6d !important;
  border-color: #2d6e6d !important;
  color: #fff;
  height: 40px;
  padding: 0px 16px 0px 16px;
  font-size: 14.22px;
  width: 500;
  line-height: 12.8px;
  font-family: "Voyado Text";
  border-radius: 4px;
  box-shadow: none;
}

.btn-danger {
  background-color: #fff;
  border: 2px solid #e0e9e8 !important;
  color: #2d6e6d;
  height: 24px;
  padding: 0px 8px 0px 8px;
  font-size: 12.64px;
  line-height: 1.4;
  border-radius: 4px;
  box-shadow: none;
  font-family: "Voyado Text";
}
.btn-danger:hover {
  background-color: #2d6e6d !important;
  border-color: #2d6e6d !important;
}
.p-disabled {
  opacity: 1;
  background-color: #e9ecef !important;
  border: none;
}
.new-tgbtn {
  font-size: 34px !important;
  margin-left: 5px !important;
}
.horizontal-align {
  display: flex;
  align-items: center;
}

.imagefit {
  margin-top: 5px;
  width: 500px;
  height: 500px;
  overflow: hidden;
  position: relative;
  max-width: 100%;
  max-height: 100%;
}
</style>
